export const QUESTIONS = [
  {
    "id": 1,
    "question": "Kathleen, a data systems analyst at a midsize tech company, is monitoring and configuring the alerts for the company\u2019s cloud-based database. The company wants to manage storage resources effectively to prevent unexpected interruptions. Kathleen wants to set a primary alert related to storage management based on a management-by-exception strategy. Which primary alert should Kathleen set up?",
    "choice_a": "An alert when the database size reaches 70 percent of the total storage capacity",
    "choice_b": "An alert when there\u2019s an unusual surge in active users",
    "choice_c": "An alert when the system encounters a sudden increase in error rates",
    "choice_d": "An alert when the database read/write ratio significantly deviates from the normal range",
    "correct_answer": "A",
    "explanation": "While all of these alerts are relevant to managing a database, this question asks specifically about storage resources, making a surge in active users, an increase in error rates, or a different read/write ratio incorrect. Since database size correlates to storage use, configuring a size-based alert is the best approach, as described in option A.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      52,
      53,
      55,
      67,
      54
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 2,
    "question": "Paige, a database administrator at a multinational company, needs to change the data type of the postal code attribute in the address table to accommodate Canadian addresses, which contain characters and numbers. Which SQL command should she use to achieve this?",
    "choice_a": "ALTER TABLE",
    "choice_b": "DROP TABLE",
    "choice_c": "CREATE TABLE",
    "choice_d": "SELECT",
    "correct_answer": "A",
    "explanation": "CREATE TABLE creates a new table, DROP TABLE permanently removes a table, and SELECT retrieves data from a table. Paige should use the ALTER TABLE command to modify the data type of an existing column in the address table.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      3,
      19,
      28,
      5,
      20
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 3,
    "question": "Raseel, a database administrator at a growing company, is responsible for designing and deploying a new database system. She must consider various assets and factors to ensure optimal performance and scalability while adhering to budget constraints. Which of the following factors should Raseel prioritize when acquiring hardware assets for the new database system?",
    "choice_a": "Storage, network bandwidth, and decorative server cases",
    "choice_b": "Processing capacity, memory, storage, and network bandwidth",
    "choice_c": "Number of database administrators, processing capacity, and storage",
    "choice_d": "Open-source software, processing capacity, and memory",
    "correct_answer": "B",
    "explanation": "Decorative server cases are irrelevant to the database system\u2019s performance, scalability, or reliability. The number of database administrators is not directly related to hardware acquisition. Open-source software is not a hardware asset. The most appropriate choice is to prioritize processing capacity, memory, storage, and network bandwidth when acquiring hardware assets.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      44,
      39,
      38,
      49,
      45
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 4,
    "question": "Brian is planning to conduct a disaster recovery test. During the test, he will relocate personnel to the hot site, activate the site, and simulate live operations by processing the same data at the hot site as the organization processes at the primary site. The primary site will be taken offline once the test is underway. What type of test is Brian planning?",
    "choice_a": "Parallel test",
    "choice_b": "Structured walk-through",
    "choice_c": "Full-interruption test",
    "choice_d": "Simulation test",
    "correct_answer": "C",
    "explanation": "Full-interruption tests activate the alternate processing facility and take the primary site offline. Parallel tests also activate the alternate facility but keep operational responsibility at the primary site. Structured walk-throughs and simulation tests do not activate the alternate site.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      141,
      132,
      135,
      134,
      133
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 5,
    "question": "Tanika is a data systems analyst at an e-commerce startup working on a class diagram using UML. Which of the following tools best suits her needs?",
    "choice_a": "Microsoft Word",
    "choice_b": "erwin",
    "choice_c": "Google Sheets",
    "choice_d": "Lucidchart",
    "correct_answer": "D",
    "explanation": "As a diagramming tool that supports UML, Lucidchart is Tanika\u2019s best option. erwin is a data modeling tool, Microsoft Word is a word processor, and Google Sheets is for maintaining spreadsheets.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      72,
      71,
      76,
      75,
      77
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 6,
    "question": "Beth\u2019s organization needs to develop policies and procedures to ensure the quality, security, privacy, and regulatory compliance of their data. She would like to identify the appropriate person to lead their data governance activities and work with stakeholders to establish policies and procedures for specific subject area domains. What role in the company would normally be responsible for developing policies and procedures for their data quality, security, privacy, and regulatory compliance and leading their data governance activities?",
    "choice_a": "Data owner",
    "choice_b": "Organizational data steward",
    "choice_c": "Subject area data steward",
    "choice_d": "Data custodian",
    "correct_answer": "B",
    "explanation": "The organizational data steward is responsible for developing policies and procedures for an organization\u2019s data quality, security, privacy, and regulatory compliance. While data owners work with data stewards to establish policies and procedures for their data domain, they are not responsible for developing policies and procedures for an organization\u2019s data quality, security, privacy, and regulatory compliance. Subject area data steward is incorrect because while they work on behalf of their data owner to handle daily tasks and are delegated governance activities, their role is specific to their subject area and not responsible for developing policies and procedures for an organization\u2019s data quality, security, privacy, and regulatory compliance. Data custodian is incorrect because their role is to implement technical controls that execute data governance policies, such as configuring applications, dashboards, and databases. While important, they are not responsible for developing policies and procedures for an organization\u2019s data quality, security, privacy, and regulatory compliance.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      82,
      84,
      87,
      95,
      103
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 7,
    "question": "Hassan is a data systems analyst at a midsize e-commerce company. He notices an increasing number of deadlocks in the company\u2019s central transaction processing database, impacting the overall performance. Which steps should Hassan take to prevent deadlocks from occurring frequently?",
    "choice_a": "Start and end transactions explicitly and minimize transaction size",
    "choice_b": "Increase the number of concurrent connections to the database",
    "choice_c": "Increase the size of the connection pool",
    "choice_d": "Increase the time period for reaping and refreshing dead connections",
    "correct_answer": "A",
    "explanation": "Deadlocks happen when two or more transactions lock a resource the other needs and block each other indefinitely. Starting and ending transactions explicitly and minimizing transaction size are two ways to prevent deadlocks from happening. Since this likely requires code changes, Hassan needs to include developers in this approach. Increasing the size of the connection pool, the time for reaping and refreshing dead connections, or the limit of concurrent connections are ways to address how clients connect to the database and don\u2019t directly impact deadlocks.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      23,
      6,
      4,
      33,
      15
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 8,
    "question": "Jenn is a software developer working on a new flight booking application. She needs to interact with a relational database storing flight data but wants to focus on the application\u2019s business logic rather than dealing with complex SQL queries. Which technique would best suit Jennifer\u2019s requirements?",
    "choice_a": "Object-oriented programming (OOP)",
    "choice_b": "User experience (UX)",
    "choice_c": "SQL execution plan optimization",
    "choice_d": "Object-relational mapping (ORM)",
    "correct_answer": "D",
    "explanation": "Object-oriented programming (OOP) makes software more modular, reusable, and scalable. User experience (UX) design focuses on improving a system\u2019s ease of use, efficiency, and usefulness. SQL execution plan optimization refers to understanding and optimizing query performance by examining database engine steps to execute a SQL query. Object-relational mapping (ORM) presents relational data as objects in an object-oriented programming language, allowing developers to work with OOP languages like Java, Python, and C++ without writing the underlying database queries.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      16,
      18,
      17,
      15,
      26
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 9,
    "question": "Hamid is a data systems analyst at an established financial services company. His primary responsibility is to ensure the database system\u2019s optimal performance. After observing a constant slowdown in the database\u2019s responsiveness, he uses Oracle Enterprise Manager to identify poorly performing queries. Exploring the execution plan for a frequently executed query that supports order processing activities, Hamid sees that the query is doing a full table scan. Hamid realizes that this is causing a bottleneck and decides to take steps to improve this query's performance. Which of the following actions would be most appropriate for Hamid?",
    "choice_a": "Rewrite the query to use joins instead of subselects",
    "choice_b": "Change the code to use bind variables",
    "choice_c": "Increase the number of cached sequence values",
    "choice_d": "Create an index to cover the query",
    "correct_answer": "D",
    "explanation": "Creating an index is the best option, as full table scans suggest an index does not cover the query. Rewriting the query to use joins instead of subselects is appropriate if the execution plan shows that the query used subselects inefficiently. Changing the code to use bind variables is appropriate if the optimizer needs to parse the query for each execution. Increasing the number of cached sequence values does not impact full table scans.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      48,
      49,
      43,
      38,
      39
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 10,
    "question": "Caroline is a senior network administrator at a logistics company and is configuring an internal firewall to allow web servers in the perimeter network to connect to a PostgreSQL database in a private network using its default port. Which network port must she open to allow traffic to reach the database?",
    "choice_a": "1521",
    "choice_b": "1433",
    "choice_c": "5432",
    "choice_d": "50000",
    "correct_answer": "C",
    "explanation": "The default port for Oracle is 1521, the default for Microsoft SQL Server is 1433, and the default for IBM Db2 is 50000. 5432 is the default port for PostgreSQL.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      111,
      114,
      92,
      85,
      88
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 11,
    "question": "Samantha is developing an application prototype and needs to store application data in a relational database. Which of the following is the most cost-effective option?",
    "choice_a": "MariaDB",
    "choice_b": "Oracle Enterprise Edition",
    "choice_c": "IBM Db2 Standard",
    "choice_d": "Cassandra",
    "correct_answer": "A",
    "explanation": "You have to pay for both Oracle Enterprise Edition and IBM Db2 Standard. While Cassandra is open-source, it is not a relational database. This makes MariaDB the optimal choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      9,
      14,
      2,
      10,
      12
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 12,
    "question": "John Paul works for a merchant that frequently handles credit card information. She would like to deploy a security control that can detect the presence of credit card records across a variety of systems. What detection technology would be best-suited for this task?",
    "choice_a": "Watermarking",
    "choice_b": "Pattern matching",
    "choice_c": "Host-based",
    "choice_d": "Network-based",
    "correct_answer": "B",
    "explanation": "John Paul should select a pattern recognition system because that technology can easily recognize the presence of data with regular patterns, such as credit card numbers. Watermarking technology would require that the organization mark every record that contains credit card data and would be difficult to use in this scenario. The choice of host-based and/or network-based monitoring depends more on where the data exists than what type of data is used. He would likely use a combination of both host-based and network-based DLP but deploy pattern recognition technology on those platforms.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      94,
      95,
      97,
      100,
      92
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 13,
    "question": "Omar is selecting a fire-suppression system for his organization\u2019s data center. He would like to use a technology that deploys water only at specific sprinkler heads when a fire is detected. He hopes that this approach will limit the damage in the facility when water is deployed. What type of system would best meet his needs?",
    "choice_a": "Wet pipe sprinkler system",
    "choice_b": "Dry pipe sprinkler system",
    "choice_c": "Pre-action sprinkler system",
    "choice_d": "Deluge sprinkler system",
    "correct_answer": "C",
    "explanation": "An appropriate fire suppression system for Omar\u2019s needs is a pre-action sprinkler system. This system requires two independent events before water is released, providing an additional layer of protection against accidental water discharge. The first event is the detection of smoke or heat, which opens a valve that fills the pipes with water. The second event occurs when a fire is detected by a separate fire detection system, which opens the sprinkler heads in the affected area to release the water. This approach reduces the risk of water damage caused by accidental sprinkler discharge or leaks. A wet pipe sprinkler system has water constantly in the pipes, which means water will flow from all activated sprinkler heads, potentially causing damage to areas that are not affected by the fire. A dry pipe sprinkler system is similar to a wet pipe system, but with air in the pipes until a fire activates the system. A deluge sprinkler system is designed for high hazard areas, where a large volume of water is needed quickly to suppress fires, and is not suitable for most data center environments.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      137,
      132,
      133,
      134,
      135
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 14,
    "question": "Omar is a data systems analyst for a large healthcare organization regulated by the Health Insurance Portability and Accountability Act (HIPAA). The vendor has just released a new patch for the company\u2019s database software. The patch is not urgent and addresses minor software defects. Omar is wondering when the best time to apply the patch would be. What should Omar do?",
    "choice_a": "Apply the patch immediately in the production environment without testing",
    "choice_b": "Ignore the patch since it is not urgent and addresses minor software defects",
    "choice_c": "Test the patch in a nonproduction environment before scheduling a time to apply it in production",
    "choice_d": "Apply the patch during peak usage hours to ensure maximum user impact",
    "correct_answer": "C",
    "explanation": "Testing the patch in a nonproduction environment is the best option. Even though the patch addresses minor defects and isn\u2019t time-sensitive, it\u2019s still essential to ensure the patch doesn\u2019t interfere with the database configuration or client applications before applying it to the production environment. Ignoring the patch could lead to support issues and is not a good choice. Applying the patch in production without testing it first is similarly unwise, as the impact of the patch is unknown.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      45,
      50,
      49,
      48,
      41
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 15,
    "question": "Sarah is a cybersecurity analyst at an online store. She is tasked with ensuring the security of the store\u2019s web applications and database server to prevent SQL injection attacks. Which of the following security measures should Sarah prioritize to protect the web applications and database server against these attacks?",
    "choice_a": "Implement browser-based input validation",
    "choice_b": "Create an input allow list on the server side",
    "choice_c": "Create an input deny list for all user inputs",
    "choice_d": "Deploy a web application firewall only",
    "correct_answer": "B",
    "explanation": "Creating an input allow list on the server side is the most effective measure to prevent SQL injection attacks, as it specifies the exact type of input expected from users and ensures only valid and safe input is accepted. Deploying a web application firewall only, while providing an additional layer of defense, should not be the sole security measure, as input validation remains the primary defense against injection attacks. Creating an input deny list for all user inputs, or input blacklisting, is less effective than input whitelisting, since attackers may still bypass the blacklist. Implementing browser-based input validation should not be relied upon as a security control, as attackers can easily bypass it.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      116,
      115,
      105,
      106,
      104
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 16,
    "question": "Gary is designing a multifactor authentication system to protect a database containing highly sensitive information. The database uses a password authentication approach already. What technology could Gary add to best secure the database?",
    "choice_a": "PIN",
    "choice_b": "Security questions",
    "choice_c": "Fingerprint recognition",
    "choice_d": "Passphrase",
    "correct_answer": "C",
    "explanation": "The system already uses a password, which is a \u201csomething you know\u201d factor. Therefore, Gary should add either a \u201csomething you have\u201d or \u201csomething you are\u201d factor. Fingerprint recognition is a \u201csomething you are\u201d (or biometric) authentication factor and would constitute multifactor authenticaiton when combined with a password. The answers to security questions, personal identification numbers (PINs), and passphrases are all \u201csomething you know\u201d factors and would not create multifactor authentication when combined with a password.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      89,
      88,
      90,
      92,
      104
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 17,
    "question": "Patrizia, a database developer at a midsize company, is in the planning phase of designing a new database. She wants to ensure that the database will meet the needs of its users and applications. Which stakeholders should Patrizia consult to gain insights into business trends and patterns using advanced analytics and predictive models?",
    "choice_a": "Executive management",
    "choice_b": "Data scientists",
    "choice_c": "System administrators",
    "choice_d": "Customers",
    "correct_answer": "B",
    "explanation": "Executive management is an important stakeholder group that uses data from the database to track operational performance metrics and inform strategic decisions. However, they typically rely on reporting tools and do not perform advanced analytics and predictive modeling directly.<br>System administrators operate the virtual or physical servers where the database runs, handling tasks such as server sizing and disk-space allocation. While they play a crucial role in the database infrastructure, they do not directly analyze the data or work on predictive models.<br>Customers typically interact with the database indirectly, using an application to submit orders or retrieve information. They are essential end users of the database but do not perform advanced analytics or develop predictive models.<br>Data scientists are essential stakeholders to consult during the planning phase of database design, as they use the database to perform advanced analytics, develop predictive models, and gain insights into business trends and patterns. Their input can help shape the database structure to support their analytical work.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      36,
      40,
      37,
      44,
      41
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 18,
    "question": "The backup administrator configures a system to perform full backups on Sundays at 1 a.m. and incremental backups on Mondays through Saturdays at 1 a.m. The system fails on Wednesday at 4 p.m. What backups must be applied?",
    "choice_a": "Sunday only",
    "choice_b": "Sunday and Wednesday only",
    "choice_c": "Sunday, Monday, and Wednesday only",
    "choice_d": "Sunday, Monday, Tuesday, and Wednesday",
    "correct_answer": "D",
    "explanation": "With incremental backups, you must first restore the most recent full backup and then apply all incremental backups that occurred since that full backup. Therefore, the administrator must restore the backups from Sunday, Monday, Tuesday, and Wednesday.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      145,
      147,
      150,
      135,
      148
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 19,
    "question": "Fayez manages a team of Java developers and wants an object-relational mapping (ORM) tool to insulate his developers from writing database-specific code. What is his best option?",
    "choice_a": "Hibernate",
    "choice_b": "ActiveRecord",
    "choice_c": "RedBean",
    "choice_d": "Django",
    "correct_answer": "A",
    "explanation": "While all of these are ORM frameworks, Django is for Python, RedBean is for PHP, and ActiveRecord is for Ruby on Rails. Hibernate is an ORM for Java.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      18,
      16,
      15,
      4,
      14
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 20,
    "question": "Zara is a database administrator at a large corporation. She wants to automate monitoring and maintenance activities on her company\u2019s database to improve operational consistency and save time for higher-value tasks. Which type of script would be most suitable for Zara\u2019s use case?",
    "choice_a": "Client-side script",
    "choice_b": "ETL",
    "choice_c": "ELT",
    "choice_d": "Server-side script",
    "correct_answer": "D",
    "explanation": "Client-side scripts run on a client machine and are vulnerable to connectivity issues. ETL and ELT scripts move data between databases. Server-side scripts run on the database server and are ideal for administrative tasks.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      30,
      33,
      34,
      6,
      4
    ],
    "source": "180059_Assessment test"
  },
  {
    "id": 21,
    "question": "Lionel is creating a financial data warehouse. Which type of database should he consider?",
    "choice_a": "Key-value",
    "choice_b": "Document",
    "choice_c": "Column-oriented",
    "choice_d": "Graph",
    "correct_answer": "C",
    "explanation": "Key-value databases are ideal for storing audio, image, and video data. Document databases store data in a JSON-like structure. Graph databases excel at exploring the relationships between data. With data stored in columns instead of rows, column-oriented databases are well-suited for aggregations in a data warehouse.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      10,
      12,
      2,
      31,
      14
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 22,
    "question": "Inaya wants to use a graph database to build an identity and access management system. Which of the following is a viable option?",
    "choice_a": "Cassandra",
    "choice_b": "Neo4j",
    "choice_c": "MongoDB",
    "choice_d": "DynamoDB",
    "correct_answer": "B",
    "explanation": "Cassandra is a column-oriented database, MongoDB is a document database, DynamoDB is a key-value database, and Neo4j is a graph database.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      12,
      10,
      13,
      14,
      2
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 23,
    "question": "Monique is a database administrator for a company managing customer information. She is optimizing the existing database structure to make it easier to retrieve customer addresses. Which database concept should she use to associate customer information with their addresses while maintaining data integrity?",
    "choice_a": "Primary Key",
    "choice_b": "Tuple",
    "choice_c": "Foreign Key",
    "choice_d": "Relation",
    "correct_answer": "C",
    "explanation": "Primary Keys uniquely identify individual rows within a table and do not directly help associate data between separate tables. Tuples contain specific data about a single data subject within a table. Relations are structures containing a collection of attributes about a data subject. Foreign Keys create a link between two tables by adding an attribute to one table that references the primary key of another table.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      20,
      25,
      2,
      3,
      5
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 24,
    "question": "Howard is a database designer for an e-commerce website working on creating a table to store customer information. He wants to ensure that each customer can be uniquely identified within the table. Which database concept should Jack use to accomplish this goal?",
    "choice_a": "Primary Key",
    "choice_b": "Tuple",
    "choice_c": "Foreign Key",
    "choice_d": "Relation",
    "correct_answer": "A",
    "explanation": "Tuples contain specific data about a single data subject within a table. Relations are structures containing a collection of attributes about a data subject. Foreign Keys create a link between two tables by adding an attribute to one table that references the primary key of another table. Primary Keys uniquely identify individual rows within a table.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      20,
      3,
      2,
      26,
      6
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 25,
    "question": "Lisa is a database administrator for a growing online retail company that requires a relational database management system to handle hundreds of concurrent connections. Lisa's company makes extensive use of Linux. Which RDBMS platform should Lisa consider for her company's needs?",
    "choice_a": "Access",
    "choice_b": "PostgreSQL",
    "choice_c": "SQL Server",
    "choice_d": "Aurora",
    "correct_answer": "B",
    "explanation": "Access is Windows only, and SQL Server is primarily for the Windows operating system. Aurora is a cloud-only database offering. PostgreSQL runs on Linux and supports thousands of concurrent connections.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      9,
      14,
      2,
      5,
      6
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 26,
    "question": "Miguel is responsible for database strategy for a growing online retail company that requires a relational database to handle what will eventually be a petabyte-scale database. Most of the company's infrastructure runs Linux in the cloud, and Miguel prefers a cloud-based solution that minimizes administrative overhead. Which RDBMS platform should Miguel consider for his company's needs?",
    "choice_a": "Access",
    "choice_b": "PostgreSQL",
    "choice_c": "SQL Server",
    "choice_d": "Aurora",
    "correct_answer": "D",
    "explanation": "Access is Windows only, and SQL Server is primarily for the Windows operating system. While PostgreSQL runs on Linux and can run in the cloud, Aurora is a cloud-only database offering.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      9,
      14,
      2,
      5,
      6
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 27,
    "question": "Allison is working on building a database for a new online store. She is developing a feature to recommend products based on similar purchases and search history. Which type of database would be best suited for Allison's needs?",
    "choice_a": "Key-value",
    "choice_b": "Document",
    "choice_c": "Column-oriented",
    "choice_d": "Graph",
    "correct_answer": "D",
    "explanation": "Key-value databases store data as a collection of keys and their corresponding values, a simplistic approach to storing data. Document databases extend the key-value concept by adding restrictions on the stored values, and column-oriented databases use an index to identify data in groups of related columns. A recommendation engine requires analyzing relationships between users and items, exactly where graph databases excel.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      13,
      10,
      12,
      14,
      2
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 28,
    "question": "Katie works for a social network startup and needs a database to store social network profiles. While profiles are all JSON documents, each profile may contain different fields. Which type of NoSQL database would be Katie's best choice?",
    "choice_a": "Key-value",
    "choice_b": "Column-oriented",
    "choice_c": "Graph",
    "choice_d": "Document",
    "correct_answer": "D",
    "explanation": "Column-oriented databases are optimal for handling columnar data, and graph databases excel at handling connected data. While a key-value database could work, a document database is ideal for storing semi-structured data.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      10,
      12,
      11,
      14,
      2
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 29,
    "question": "Andy is building an environment to analyze five decades worth of financial transactions. If Andy uses commodity servers and a column-oriented design, which of the following databases best fits Andy's needs?",
    "choice_a": "MySQL",
    "choice_b": "MongoDB",
    "choice_c": "Cassandra",
    "choice_d": "SQLite",
    "correct_answer": "C",
    "explanation": "MySQL and SQLite are relational databases, and MongoDB is a document database. Of the options, only Cassandra supports a column-oriented design.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      10,
      2,
      14,
      1
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 30,
    "question": "Sameer is a software developer working on a project that requires storing and managing JSON data. He is considering different approaches to storing the data. Which of the following best describes what Sameer should choose for this project.",
    "choice_a": "Relational database with linear data format",
    "choice_b": "NoSQL database with nonlinear data format",
    "choice_c": "Relational database with nonlinear data format",
    "choice_d": "NoSQL database with linear data format",
    "correct_answer": "B",
    "explanation": "A relational database with linear data format is ideal for tabular data, and a relational database with nonlinear data format and a NoSQL database with linear data format are not recommended approaches. As JSON objects are nonlinear, a NoSQL database is the best option.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      11,
      10,
      2,
      14,
      16
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 31,
    "question": "Luca is a software developer working on an application that requires interaction with a relational database. He is considering using an ORM framework to simplify his work. What is the primary benefit of using an ORM framework in this context?",
    "choice_a": "Reduces the size of the database",
    "choice_b": "Allows developers to work with data using object-oriented programming languages",
    "choice_c": "Increases the number of supported database platforms",
    "choice_d": "Makes the database more secure",
    "correct_answer": "B",
    "explanation": "ORM frameworks don't have a direct impact on the size of the database and do not inherently improve security. While ORM frameworks can help make the code more portable and adaptable to different database platforms, their primary purpose is to provide an abstraction layer that allows developers to work with data using object-oriented programming languages.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      16,
      18,
      15,
      19,
      35
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 32,
    "question": "Enzo is a software developer working on a project incorporating nonlinear data to support a new initiative at his company. Which type of database would be the most appropriate choice for this situation?",
    "choice_a": "Relational database",
    "choice_b": "NoSQL database",
    "choice_c": "Flat-file database",
    "choice_d": "Spreadsheet",
    "correct_answer": "B",
    "explanation": "Graph databases are specifically designed for handling highly interconnected datasets and would be the best choice in this scenario. Both relational and flat-file databases are better for linear data, and spreadsheets are not databases. Of the listed options, NoSQL databases are best suited to handling nonlinear data.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      10,
      13,
      2,
      14,
      11
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 33,
    "question": "Gina is a developer in a growing organization that uses a relational database for its linear data. They have recently identified the need to store and manage highly interconnected data for product recommendations. Which type of database would be the most appropriate choice for this situation?",
    "choice_a": "Relational",
    "choice_b": "Graph",
    "choice_c": "Key-value",
    "choice_d": "Column-oriented",
    "correct_answer": "B",
    "explanation": "Relational databases are more suited for linear data, key-value databases store data as key-value pairs, and column-oriented databases store data as columns instead of rows.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      10,
      2,
      14,
      12
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 34,
    "question": "Jane is a software developer working on a file-based interface sending employee data to her company's insurance provider. She needs a format that is easy to create, read, and write. Which file format should she choose?",
    "choice_a": "JSON",
    "choice_b": "XML",
    "choice_c": "CSV",
    "choice_d": "BSON",
    "correct_answer": "C",
    "explanation": "JSON is a file format used for representing structured data, XML represents data in a tree-like structure of nested objects and elements, and BSON (Binary JSON) is a binary serialization format used for storing JSON documents. CSVs are simple, easy to create, read, and write, and are a popular choice for storing and exchanging data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      2,
      10,
      31,
      5
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 35,
    "question": "Ron is developing an application that requires storing complex data structures with hierarchical relationships. He needs a file format that can effectively represent these relationships and be easily readable. Which file format should he choose? Select the best answer.",
    "choice_a": "CSV",
    "choice_b": "DOCX",
    "choice_c": "JSON",
    "choice_d": "XML",
    "correct_answer": "D",
    "explanation": "CSVs are simple, comma-separated files, ill-suited to storing complex data. DOCX is an Open Office XML document specific for word processing. While JSON is a viable choice, it may not be as easily readable as XML, particularly when working with more complex data structures. The tags within an XML document facilitate readability.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      11,
      10,
      12,
      13,
      2
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 36,
    "question": "Katie is designing a web application requiring an efficient approach for exchanging structured data between clients and the server. The application must easily parse and generate data in this format. Which file format should she choose? Select the best option.",
    "choice_a": "XML",
    "choice_b": "CSV",
    "choice_c": "JSON",
    "choice_d": "TSV",
    "correct_answer": "C",
    "explanation": "CSVs are simple, comma-separated files, ill-suited to storing and transmitting structured data. TSVs are similar to CSVs, using tabs instead of commas as the separator. While XML is a viable choice, JSON is more efficient.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      11,
      2,
      16,
      10,
      5
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 37,
    "question": "Christa is working on an application that requires storing and managing a list of customer records, each with a fixed number of fields, such as name, email address, and phone number. The data will be used for simple data analysis and primarily accessed sequentially. Which type of data format should Christa choose for this task?",
    "choice_a": "Linear data format",
    "choice_b": "Nonlinear data format",
    "choice_c": "Graph data format",
    "choice_d": "Tree data format",
    "correct_answer": "A",
    "explanation": "Nonlinear data formats are ideal for hierarchical or nested structures, graph data formats map in the form of nodes and relationships, and tree data formats represent data in a hierarchical structure, similar to a nonlinear data format. As Christa is working with linear data, she should choose a linear data format.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      2,
      14,
      10,
      31
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 38,
    "question": "Swan is a software developer working on a project to improve his company's application. He is enhancing the overall user interaction and ensuring that the application is intuitive and user-friendly. Which aspect of the application should Swan focus on?",
    "choice_a": "UX",
    "choice_b": "Database optimization",
    "choice_c": "APIs",
    "choice_d": "Load balancing",
    "correct_answer": "A",
    "explanation": "Database optimization involves improving the performance of a database system, and load balancing distributes network traffic across multiple resources. APIs allow different software components to interact with each other. UX focuses on enhancing the experience users have with an application.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      16,
      5,
      18,
      17
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 39,
    "question": "Sven is a development manager at a financial services firm. He wants to create a software system that is easy to maintain, scale, and modify. He's considering using a design principle focusing on object interaction and encapsulating data and behavior. What design principle should Sven use for his application?",
    "choice_a": "Functional programming",
    "choice_b": "Object-oriented programming",
    "choice_c": "Procedural programming",
    "choice_d": "Logic programming",
    "correct_answer": "B",
    "explanation": "Functional, procedural, and logic programming all encapsulate logic into subcomponents. Object-oriented programming differs by focusing programming on data objects instead of procedural flow.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      18,
      2,
      10,
      14
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 40,
    "question": "Monique is a development manager for a group of Java programmers. Which of the following ORM frameworks should she evaluate to abstract away the structural details of a relational database and facilitate more reusable and maintainable code?",
    "choice_a": "ActiveRecord",
    "choice_b": "Django",
    "choice_c": "Hibernate",
    "choice_d": "LINQ",
    "correct_answer": "C",
    "explanation": "LINQ is an ORM for .NET, ActiveRecord is built into Ruby on Rails, and Django is an ORM for Python. Hibernate is an ORM for Java.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      18,
      16,
      15,
      2,
      5
    ],
    "source": "180059_Ch02"
  },
  {
    "id": 41,
    "question": "Eve needs to change the value of an existing customer's address in the database. What DML command should she use?",
    "choice_a": "INSERT",
    "choice_b": "SELECT",
    "choice_c": "UPDATE",
    "choice_d": "DELETE",
    "correct_answer": "C",
    "explanation": "Since Eve is modifying existing information, she needs to use the UPDATE command. SELECT retrieves data, INSERT creates new data, and DELETE removes existing data.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      21,
      3,
      19,
      23,
      24
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 42,
    "question": "Satish is working on automating the deployment of database software patches in a Linux environment. Which of the following approaches describes his optimal choice?",
    "choice_a": "Implement a client-side script using Python.",
    "choice_b": "Implement a server-side script using Bash.",
    "choice_c": "Implement a client-side script using PowerShell.",
    "choice_d": "Implement a server-side script using Batch.",
    "correct_answer": "B",
    "explanation": "A client-side approach is ruled out because patching database software is a network-sensitive task. Batch is a scripting language for Windows servers that would not work in a Linux environment, leaving option B as the most viable choice.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      30,
      32,
      34,
      4,
      33
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 43,
    "question": "Monica is a database administrator at a midsize company. She wants to create a new table named Employees and ensure that every row has a unique identifier in the <i>employee_id</i> column, which cannot be NULL. She also wants to specify data types for each column. Which SQL flavor and commands should Susan use to achieve this?",
    "choice_a": "Data Definition Language (DDL); CREATE TABLE, ALTER TABLE",
    "choice_b": "Data Definition Language (DDL); INSERT, SELECT",
    "choice_c": "Data Manipulation Language (DML); CREATE TABLE, ALTER TABLE",
    "choice_d": "Data Manipulation Language (DML); INSERT, SELECT",
    "correct_answer": "A",
    "explanation": "Option B combines DDL with DML statements incorrectly, while the DML SQL flavor in options C and D are incorrect. Monica is performing DDL tasks, in which she creates a table and then alters it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      3,
      20,
      29,
      28
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 44,
    "question": "Jenny is a data analyst at a midsize company. She needs to retrieve data on specific clients from a table and update their contact information based on the latest data provided. Which flavor of SQL should Jenny use to perform these tasks?",
    "choice_a": "Data Definition Language (DDL)",
    "choice_b": "Data Control Language (DCL)",
    "choice_c": "Transaction control language (TCL)",
    "choice_d": "Data Manipulation Language (DML)",
    "correct_answer": "D",
    "explanation": "Data Definition Language (DDL) creates, alters, or removes database objects, Data Control Language (DCL) controls access and permissions to database objects, and a transaction control language (TCL) manages transactions within a database system. Data Manipulation Language (DML) performs Create, Read, Update, and Delete (CRUD) operations on data within a database.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      21,
      19,
      3,
      23,
      24
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 45,
    "question": "In a company database, there are two tables: Employees and Salaries. The Employees table has the following columns: <i>EmployeeID</i>, <i>FirstName</i>, <i>LastName</i>, and <i>Department</i>. The Salaries table has the following columns: <i>EmployeeID</i>, <i>Salary</i>, and <i>Bonus</i>. Bob, the HR manager, wants to see a list of employees who work in the IT department, along with their total annual income (Salary + Bonus). Which SQL query should Bob use to retrieve this information?",
    "choice_a": "SELECT Employees.FirstName, Employees.LastName, (Salaries.Salary + Salaries.Bonus) AS TotalAnnualIncome <br>FROM Employees <br>INNER JOIN Salaries ON Employees.EmployeeID = Salaries.EmployeeID",
    "choice_b": "SELECT Employees.FirstName, Employees.LastName, (Salaries.Salary + Salaries.Bonus) AS TotalAnnualIncome <br>FROM Employees <br>INNER JOIN Salaries ON Employees.EmployeeID = Salaries.EmployeeID <br>WHERE Employees.Department = 'HR'",
    "choice_c": "SELECT Employees.FirstName, Employees.LastName, Salaries.Salary, Salaries.Bonus <br>FROM Employees <br>JOIN Salaries ON Employees.EmployeeID = Salaries.EmployeeID <br>WHERE Employees.Department = 'IT'",
    "choice_d": "SELECT Employees.FirstName, Employees.LastName, (Salaries.Salary + Salaries.Bonus) AS TotalAnnualIncome <br>FROM Employees <br>JOIN Salaries ON Employees.EmployeeID = Salaries.EmployeeID <br>WHERE Employees.Department = 'IT'",
    "correct_answer": "D",
    "explanation": "Option A doesn\u2019t have a WHERE clause and retrieves the information for all employees. Option B matches employees in the HR department, not the IT department. Option C retrieves the correct data but doesn\u2019t combine the salary and bonus information. Option D correctly retrieves the appropriate columns, joins the table, and filters on the proper department.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      21,
      27,
      3,
      20
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 46,
    "question": "The following SQL query should retrieve a list of products, prices, and categories from a database for all products that cost more than $50. However, the SQL statement does not work as written:<br>SELECT ProductName, Price, Category <br>FROM Products <br>INNER JOIN Categories ON Products.CategoryID Categories.CategoryID <br>WHERE Price > 50;<br>Which of the following options should be applied to correct the SQL query?",
    "choice_a": "Replace the INNER JOIN with a LEFT JOIN.",
    "choice_b": "Set Products.CategoryID = Categories.CategoryID in the ON clause.",
    "choice_c": "Change the WHERE clause to look for Price >= 50.",
    "choice_d": "Set Products.CategoryID - Categories.CategoryID in the ON clause.",
    "correct_answer": "B",
    "explanation": "The original SQL query has a missing equal sign (=) in the ON clause of the INNER JOIN, which results in a syntax error. Option B corrects the error by including the equal sign in the ON clause, making the join condition complete and accurate. Option A still results in an error, option C changes the filter but doesn\u2019t address the join error, and option D doesn\u2019t address the join error.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      25,
      3,
      20,
      28,
      21
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 47,
    "question": "Alex is a data analyst at an online retail company. He needs to determine the total revenue generated for each product category in each country. The company\u2019s database has a table called orders with the following columns: <i>country</i>, <i>product_category</i>, and <i>revenue</i>. Which of the following SQL queries should Alex use to achieve his goal?",
    "choice_a": "SELECT country <br>,product_category <br>,SUM(revenue) AS total_revenue <br>FROM orders",
    "choice_b": "SELECT country <br>,product_category <br>,SUM(revenue) AS total_revenue <br>FROM orders <br>GROUP BY country",
    "choice_c": "SELECT country <br>,product_category <br>,SUM(revenue) AS total_revenue <br>FROM orders <br>GROUP BY country, product_category",
    "choice_d": "SELECT SUM(revenue) AS total_revenue <br>FROM orders <br>GROUP BY country, product_category",
    "correct_answer": "C",
    "explanation": "Option A does not use a GROUP BY clause, option B only groups the rows by <i>country</i>, and option D omits the <i>country</i> and <i>product_category</i> columns in the SELECT clause.<br>Option C correctly uses the GROUP BY clause to group the rows by <i>country</i> and <i>product_category</i> and then calculates the sum of the revenue column within each group. The result set will display the total revenue for each product category in each country.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      27,
      21,
      3,
      25,
      26
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 48,
    "question": "Xavier is a data analyst at a medium-sized company. He is working on a report and needs customers\u2019 full names and work addresses. The customer information exists in two related tables: Customer, containing name data, and Address, containing work address data. Xavier needs to join these tables together to create the desired report. Which type of join should he use to retrieve the required information?",
    "choice_a": "INNER JOIN",
    "choice_b": "LEFT JOIN",
    "choice_c": "RIGHT JOIN",
    "choice_d": "FULL JOIN",
    "correct_answer": "A",
    "explanation": "A LEFT JOIN returns every row from the Customer table, even if there is no matching address information in the Address table; a RIGHT JOIN returns every row from the Address table, even if there is no matching customer information in the Customer table; and a FULL JOIN combines the results of both LEFT JOIN and RIGHT JOIN, returning all rows from both tables. An INNER JOIN is appropriate because Xavier must retrieve rows for customers with a work address.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      25,
      20,
      21,
      29,
      26
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 49,
    "question": "Andy is a systems analyst at a growing e-commerce company. He needs to create a report that includes all customers, their full names, and their shipping addresses, if available. The customer information exists in two related tables: Customer, containing name data, and Address, containing address data. Andy must join these tables together to get the data he needs. Which type of join should Andy use to retrieve the required information?",
    "choice_a": "INNER JOIN",
    "choice_b": "LEFT JOIN",
    "choice_c": "RIGHT JOIN",
    "choice_d": "FULL JOIN",
    "correct_answer": "B",
    "explanation": "An INNER JOIN returns only the rows where customers have addresses. A RIGHT JOIN returns every row from the Address table, even if there is no matching customer data in the Customer table, and a FULL JOIN combines the results of both LEFT JOIN and RIGHT JOIN, returning all rows from both tables. Andy needs to use a LEFT JOIN to retrieve every row from the Customer table, even if there is no matching address information in the Address table.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      25,
      20,
      29,
      21,
      26
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 50,
    "question": "Sherry is a database administrator at a regional bank. She needs to create a mechanism that automatically sends low-balance alert notifications to customers whenever their account balance falls below a certain threshold. Which database object should Sherry use to accomplish this task?",
    "choice_a": "Stored procedure",
    "choice_b": "Function",
    "choice_c": "Before-update trigger",
    "choice_d": "After-update trigger",
    "correct_answer": "D",
    "explanation": "Stored procedures and functions do not automatically execute when an event occurs. A before-update trigger takes action before the intended data modification. An after-update trigger is the right choice for this scenario, as it executes automatically after a data modification.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      34,
      33,
      23,
      6
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 51,
    "question": "Gina is a data analyst for a large e-commerce organization. She wants to understand sales volume over the past three hours, getting the required data from the database. Which type of script should she use to minimize the impact on the database server?",
    "choice_a": "Server-side script",
    "choice_b": "Client-side script",
    "choice_c": "ETL script",
    "choice_d": "ELT script",
    "correct_answer": "B",
    "explanation": "A server-side script consumes resources on the database server, while extract, transform, load (ETL) and extract, load, transform (ELT) scripts typically migrate data between databases. Client-side scripts consume resources on the client machine, sending instructions to the database server only over a network connection.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      30,
      35,
      34,
      4,
      32
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 52,
    "question": "Bushra, a database administrator, must apply a security patch to the database software for her company\u2019s financial system. Which type of script would be best suited for this task?",
    "choice_a": "Server-side script",
    "choice_b": "Client-side script",
    "choice_c": "ETL script",
    "choice_d": "ELT script",
    "correct_answer": "A",
    "explanation": "A client-side script is vulnerable to network problems, while extract, transform, load (ETL) and extract, load, transform (ELT) scripts typically migrate data between databases. A server-side script is well-suited for administrative tasks like applying security patches to database software.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      30,
      34,
      33,
      4,
      32
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 53,
    "question": "Peter, a database administrator, is working on a project where he needs to perform maintenance tasks within a Microsoft SQL Server database. Which scripting language would be most appropriate for Peter?",
    "choice_a": "JavaScript",
    "choice_b": "Python",
    "choice_c": "T-SQL",
    "choice_d": "Bash",
    "correct_answer": "C",
    "explanation": "JavaScript, Python, and Bash are general-purpose programming languages without native SQL Server support. T-SQL runs within Microsoft SQL Server, allowing for flow control and exception handling.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      24,
      33,
      30,
      28
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 54,
    "question": "Sandy, a database developer, wants to automate extracting transactional data from a Linux-based PostgreSQL database and reshaping it for analytical purposes. Which scripting language would be the most appropriate choice for her to use for client-side automation tasks?",
    "choice_a": "Bash",
    "choice_b": "T-SQL",
    "choice_c": "PL/SQL",
    "choice_d": "Python",
    "correct_answer": "D",
    "explanation": "T-SQL is Microsoft\u2019s proprietary extension of SQL, and PL/SQL is Oracle\u2019s language for developing stored procedures. While Bash is useful for everyday administrative tasks on the server, Python is more versatile, with numerous packages that facilitate text manipulation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      32,
      4,
      30,
      31
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 55,
    "question": "Tracey is a database administrator who needs to automate a set of administrative tasks on a Windows Server. She wants a modern scripting language that provides a feature-rich, advanced environment for automating tasks in Windows. Which scripting language should Tracey choose?",
    "choice_a": "Batch scripts",
    "choice_b": "PowerShell",
    "choice_c": "VBScript",
    "choice_d": "Java",
    "correct_answer": "B",
    "explanation": "Java is a general-purpose programming language not designed explicitly for Windows administration, Batch scripts are primitive, and VBScript is a scripting language that predates PowerShell. PowerShell is a powerful and flexible scripting language designed specifically for Windows environments, making it an ideal choice for Tracey\u2019s administrative tasks on a Windows Server.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      4,
      32,
      33,
      30,
      6
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 56,
    "question": "As a Linux DevOps engineer, Joe needs to automate a series of administrative tasks on a Linux server. He wants to use a native scripting language so the scripts he develops will run on virtually any Linux machine. Which language should Joe use for his automation needs?",
    "choice_a": "Python",
    "choice_b": "PowerShell",
    "choice_c": "Batch",
    "choice_d": "Bash",
    "correct_answer": "D",
    "explanation": "PowerShell is designed primarily for Windows, and Batch scripts work only on Windows. While you can use Python for automation, it is not native in all Linux environments. Bash is a widely used shell and scripting language for Unix-like operating systems, including Linux.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      32,
      4,
      33,
      34,
      35
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 57,
    "question": "Elinor is a business intelligence manager at a medium-sized company. Her team is responsible for migrating data from the company\u2019s transactional databases to a data warehouse. Given her team\u2019s existing Python expertise, she wants to choose the best data migration approach. Which approach should Elinor consider for this data migration?",
    "choice_a": "ETL",
    "choice_b": "ELT",
    "choice_c": "FTP",
    "choice_d": "API",
    "correct_answer": "A",
    "explanation": "File Transfer Protocol (FTP) is a protocol for transferring files between computers, and application programming interfaces (APIs) are interfaces between systems. While extract, load, and transform (ELT) is a valid approach, it puts more load on the database and doesn\u2019t take advantage of her team\u2019s existing skills. ETL is the best approach for Elinor, as she can leverage her team\u2019s Python skills for the complex transformation work.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      4,
      35,
      32,
      5
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 58,
    "question": "Maggie is a database administrator at a software development company. She needs to implement a database object that automatically enforces a business rule whenever a user\u2019s email address changes. Which database object should Maggie create?",
    "choice_a": "Stored procedure",
    "choice_b": "View",
    "choice_c": "Trigger",
    "choice_d": "Function",
    "correct_answer": "C",
    "explanation": "While stored procedures and functions encapsulate business logic, they require invocation. A view is a virtual table that presents the result set of a SELECT statement. A trigger is the most appropriate object for this use case, as it executes SQL automatically when a specific event occurs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      26,
      34,
      33,
      3
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 59,
    "question": "Julia is a database developer at an e-commerce company. She needs to implement a reusable and precompiled set of SQL statements to handle order processing, which involves updating inventory, creating an order record, and recording the transaction history. Which database object should Julia create to achieve this?",
    "choice_a": "Trigger",
    "choice_b": "Stored procedure",
    "choice_c": "View",
    "choice_d": "Function",
    "correct_answer": "B",
    "explanation": "A stored procedure is ideal for this scenario, as it uses a precompiled set of SQL statements stored within the database and implements complex flow control logic with a single invocation. Functions are too limited in scope, and while triggers are useful for enforcing business rules, they don\u2019t provide the same flow control and reusability as stored procedures. A view is a virtual table presenting the result set of a SELECT statement and is inappropriate for this use case.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      24,
      34,
      23,
      26,
      3
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 60,
    "question": "Allison is a database developer at a software company. She needs to ensure that a series of SQL statements execute as a single atomic unit, and if any statement within this group fails, the entire group of statements reverts to its original state. Which transaction control language (TCL) command should Allison use to accomplish this task?",
    "choice_a": "BEGIN TRANSACTION",
    "choice_b": "COMMIT",
    "choice_c": "ROLLBACK",
    "choice_d": "SAVEPOINT",
    "correct_answer": "A",
    "explanation": "Using the BEGIN TRANSACTION command, Allison starts a new transaction and ensures that a series of SQL statements execute as a single atomic unit. If any statement within the transaction fails, the entire transaction will revert to its original state, maintaining data consistency. COMMIT saves the changes made by the statements in a transaction, ROLLBACK reverts any changes made during the current transaction, and SAVEPOINT creates a marker within the current transaction in case you don\u2019t want to revert all changes during a rollback.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      23,
      3,
      21,
      24,
      28
    ],
    "source": "180059_Ch03"
  },
  {
    "id": 61,
    "question": "Samia is a database developer tasked with designing a new database system for a retail company. Before she proceeds with the design, she needs to gather requirements from stakeholders. Which stakeholders should Samia primarily consult with during the planning phase to inform the database design?",
    "choice_a": "End users",
    "choice_b": "Executive management",
    "choice_c": "Regulators",
    "choice_d": "Legal team",
    "correct_answer": "A",
    "explanation": "Executive management are important data users, but they primarily use reporting tools to track operational performance and inform strategic decisions. They do not typically interact directly with the database and might not provide detailed input on specific design aspects.<br>Regulators are concerned with compliance and regulatory aspects of the database, such as HIPAA or PCI-DSS. Although important, their focus is not primarily on informing the database design but ensuring that it meets industry or government regulations.<br>Legal teams review the database for compliance with legal requirements or litigation preparation. They are not directly involved in designing the database but might provide input on aspects related to legal compliance.<br>End users are the ones who directly input or retrieve data from the database, making them essential stakeholders in gathering requirements to ensure the database meets their needs and expectations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      37,
      40,
      41,
      44
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 62,
    "question": "Bassim, a database administrator at a large organization, is working on the database design for a new project. To ensure the database meets the needs of its users and applications, he must gather requirements from stakeholders. Which of the following stakeholders is most likely to be responsible for operating the virtual or physical servers where the database runs?",
    "choice_a": "Data analysts",
    "choice_b": "Application developers",
    "choice_c": "Database developers",
    "choice_d": "System administrators",
    "correct_answer": "D",
    "explanation": "Data analysts use the database to perform complex queries, generate reports, and carry out other data-related tasks. While they are important stakeholders, they do not manage the servers where the database runs.<br>Application developers write applications that interact with the database using programming languages like JavaScript, Java, and C#. While they contribute to the project, they do not directly manage the server infrastructure for the database.<br>Database developers write SQL to create tables, views, stored procedures, and other database objects, so they might be involved in maintaining or upgrading the database. However, they do not directly operate the database servers.<br>System administrators are responsible for operating the virtual or physical servers where the database runs. They handle tasks such as sizing servers, allocating and configuring disk space, and operating system upgrades and maintenance, making them essential stakeholders in gathering requirements for database design.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      36,
      44,
      45,
      42,
      38
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 63,
    "question": "Giacomo is a database developer for a growing e-commerce company. The company wants to enhance the storage and retrieval of its customer and order data. Giacomo\u2019s supervisor asks Giacomo to analyze the current database setup to identify improvements to the system. Which of the following factors should Giacomo consider in order to determine the appropriate storage type for the company\u2019s database?",
    "choice_a": "Data capture requirements",
    "choice_b": "Volume and velocity of data",
    "choice_c": "Data processing techniques",
    "choice_d": "Data security classifications",
    "correct_answer": "B",
    "explanation": "Data capture requirements are relevant when collecting, validating, and cleaning data, ensuring accuracy and completeness. While important, data capture is separate from determining the appropriate storage type for a database.<br>Data processing techniques are essential when considering data aggregation, calculations, and transformations within the database. Although data processing is an important aspect of database management, it does not directly help determine the storage type for the database.<br>Data security classifications help ensure the security and privacy of data stored in the database by grouping individual data elements into categories. While data security is a critical aspect of database management, it does not directly determine the appropriate storage type for a database.<br>When determining the appropriate storage type for a database, Giacomo should consider the volume (how much data is stored) and the velocity (how quickly data changes). This analysis helps inform the size of the database and how much storage capacity it will need. Depending on the results of this analysis, the company may choose to use solid-state drives (SSDs), hard disk drives (HDDs), or a combination of both for their storage needs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      38,
      39,
      37,
      44,
      49
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 64,
    "question": "Leila is a database administrator at a large healthcare organization. She is designing a database that will provide real-time access to patient information for medical staff, as well as historical reporting for the organization's management. Which of the following database designs would best meet these requirements?",
    "choice_a": "Implement a transactional database only.",
    "choice_b": "Implement a data warehouse only.",
    "choice_c": "Implement a transactional database and an analytical database.",
    "choice_d": "Implement a database with a single use case.",
    "correct_answer": "C",
    "explanation": "A transactional database would provide real-time data access but is not ideal for historical reporting and analytical needs.<br>Implementing a data warehouse would not provide real-time data access for medical staff, as data warehouses primarily store historical data and support analytical activities. Although a data warehouse can facilitate reports and business intelligence, it is not suitable for real-time transaction processing.<br>Implementing a single use case database would not meet the requirements of providing real-time access to patient information for medical staff and historical reporting for the organization\u2019s management. When designing a database system with both transactional and analytical requirements, planning for a transactional database to support operational use cases and an analytical database for reporting purposes is best. The transactional database can handle real-time data access for medical staff, while the analytical database, such as a data warehouse, can facilitate historical reporting for the organization\u2019s management.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      37,
      40,
      36,
      41,
      45
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 65,
    "question": "Coleman is the lead database designer for an e-commerce company that requires a database to store and manage customer information, product inventory, and financial transactions. The company also wants to analyze historical sales data and predict future trends. Coleman has identified several use cases and grouped them into categories. Which use case category should Coleman focus on for designing the company\u2019s database to facilitate predictions and trend analysis?",
    "choice_a": "Data capture",
    "choice_b": "Data storage",
    "choice_c": "Data retrieval",
    "choice_d": "Data analysis",
    "correct_answer": "D",
    "explanation": "Data capture is a use-case category focusing on collecting, validating, and cleaning data for accuracy and completeness. While important, data capture does not directly address the company\u2019s requirements for analyzing historical sales data and predicting future trends.<br>Data storage is a use case category that impacts the type of storage needed, informed by size and speed requirements. Although data storage is essential in designing the database, it does not directly address the company\u2019s requirements for analyzing historical sales data and predicting future trends.<br>Data retrieval is a use-case category that focuses on how users access the data they need from the database. While data retrieval is essential in designing the database, it does not directly address the company\u2019s requirements for analyzing historical sales data and predicting future trends.<br>The data analysis use-case category focuses on using data from the database to develop insights for making data informed decisions. Coleman can ensure that the e-commerce company\u2019s database supports data mining, predictive modeling, and trend analysis by focusing on data analysis. Data scientists are typically the primary constituents in this use-case category.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      40,
      36,
      43,
      44
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 66,
    "question": "Diane is a database administrator at a rapidly growing company. Her organization wants to move its database to the cloud to keep up with increasing data and users without sacrificing performance and with minimal overhead. Which cloud-hosted environment should Diane recommend?",
    "choice_a": "Infrastructure as a service (IaaS)",
    "choice_b": "Platform as a service (PaaS)",
    "choice_c": "Software as a service (SaaS)",
    "choice_d": "On-premises data center",
    "correct_answer": "B",
    "explanation": "Infrastructure as a service (IaaS) is incorrect because, while it abstracts away physical hardware, engineers are still needed to build, operate, and maintain servers. IaaS offers less abstraction and less ease of administration compared to PaaS.<br>Software as a service (SaaS) is incorrect because it delivers functioning software applications over the Internet, and the hardware, database version, and application software are opaque to the user. SaaS is unsuitable for Diane\u2019s organization\u2019s custom database infrastructure needs.<br>On-premises data center is incorrect because Diane\u2019s organization wants to move its database to the cloud to ensure scalability and performance. An on-premises data center would not provide the flexibility and ease of management that cloud-based solutions offer.<br>Platform as a service (PaaS) is a cloud-computing tier that provides a platform for users to develop, deploy, and manage applications without worrying about the underlying infrastructure. It goes further than IaaS by abstracting the management of virtual servers and database software. PaaS providers offer various database-management tools and services, reducing the effort to administer, operate, monitor, backup, and recover the database. PaaS is the ideal choice for Diane\u2019s organization to maintain performance and scalability in a growing environment.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      42,
      39,
      44,
      45,
      49
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 67,
    "question": "Jenna, the lead IT engineer at a midsize company, is selecting the appropriate cloud environment for its new database. She aims to maintain flexibility and control over the server configuration while outsourcing the physical infrastructure. She needs to determine which cloud environment is most suitable for her needs. Which of the following should Jenna choose?",
    "choice_a": "Infrastructure as a service (IaaS)",
    "choice_b": "Platform as a service (PaaS)",
    "choice_c": "Software as a service (SaaS)",
    "choice_d": "On-premises data center",
    "correct_answer": "A",
    "explanation": "Platform as a service (PaaS) is not the correct answer because, although it also outsources the physical infrastructure, it abstracts the management of virtual servers and database software. As a result, Jenna would have less control and flexibility than IaaS.<br>Software as a service (SaaS) is not the correct answer because it provides fully functioning software applications over the Internet, with hardware and database versions being opaque to the user. Jenna would have no control over the server configuration in a SaaS environment.<br>On-premises environment is not the correct answer because it requires Jenna\u2019s organization to manage the physical infrastructure, including data centers, servers, and other hardware. This option doesn\u2019t fulfill her goal of outsourcing the physical infrastructure.<br>Infrastructure as a service (IaaS) is the correct answer because it gives Jenna the flexibility and control she desires over server configuration while outsourcing the physical infrastructure. With IaaS, Jenna can customize virtual servers to meet the needs of her organization.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      42,
      44,
      39,
      38,
      45
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 68,
    "question": "Karen is a database designer for a logistics company. She is designing a new database for the company to store and manage customer and package information. Which of the following design steps should Karen perform first to establish a clear understanding of the organization\u2019s business requirements? Choose the best answer.",
    "choice_a": "Physical schema design",
    "choice_b": "Logical schema design",
    "choice_c": "Conceptual data modeling",
    "choice_d": "Implementing access controls",
    "correct_answer": "C",
    "explanation": "Physical schema design occurs after conceptual data modeling and logical design. It involves a detailed, low-level representation of the database structure, including technical details necessary for physical implementation.<br>Logical schema design is also a later step in the design process, following conceptual data modeling. The goal of logical schema design is to refine the data model, identify the attributes of each entity, and normalize the structure of the entities.<br>Implementing access controls is a way of implementing business requirements.<br>Conceptual data modeling is the correct answer because it is the first step in the design process. It is a high-level representation of an organization\u2019s data that defines the relationships between entities without including implementation details. Conceptual data modeling aims to document an organization\u2019s business requirements and facilitate communication and collaboration between stakeholders, such as business analysts, developers, and end users.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      36,
      37,
      40,
      43,
      41
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 69,
    "question": "Jennifer is a database administrator tasked with improving the structure of her company\u2019s database to minimize data duplication. She decides to apply normalization principles to the existing database. Which of the following normal forms is the first to define that all nonprimary key values must depend on the entire primary key?",
    "choice_a": "First normal form (1NF)",
    "choice_b": "Second normal form (2NF)",
    "choice_c": "Third normal form (3NF)",
    "choice_d": "Prime normal form (PNF)",
    "correct_answer": "B",
    "explanation": "First normal form (1NF) is incorrect because it only ensures that every row in a table is unique and every column contains a unique value. It does not specifically address the dependency of nonprimary key values on the primary key.<br>Third normal form (3NF) is incorrect because it builds upon 2NF by adding a rule stating all columns must depend on only the primary key.<br>Prime normal form (PNF) is a fictitious normal form.<br>Second normal form (2NF) is the correct answer because it ensures that all nonprimary key values must depend on the entire primary key. 2NF picks up where 1NF leaves off, with each row being unique, and applies an additional rule to achieve the desired structure. This normal form helps eliminate redundancy and reduce the possibility of data anomalies.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      43,
      48,
      51,
      37,
      40
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 70,
    "question": "Sofia is a database administrator for a logistics company and is designing a new database for the organization. She needs to visually represent the database structure, depicting entities and their relationships. Which of the following artifacts should she create to achieve this goal?",
    "choice_a": "Data dictionary",
    "choice_b": "Entity-relationship diagram (ERD)",
    "choice_c": "Business requirements document (BRD)",
    "choice_d": "Functional requirements document (FRD)",
    "correct_answer": "B",
    "explanation": "A data dictionary provides valuable metadata about database objects\u2019 structure, definition, and relationships. However, it does not visually represent the database structure and the relationships between entities.<br>A business requirements document (BRD) outlines a project\u2019s high-level business objectives and requirements.<br>A functional requirements document (FRD) describes the functional requirements for a database, such as use cases, user roles, input and output requirements, and data processing rules.<br>An entity-relationship diagram (ERD) is a visual artifact representing entities and their relationships within a database. ERDs help administrators, developers, and analysts understand the database structure and the connections between entities.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      43,
      37,
      36,
      40,
      41
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 71,
    "question": "Asad is a network administrator at a midsize company that plans to deploy a new database server. His primary concern is securing the database server while allowing access from authorized applications. Which of the following approaches should Asad implement to enhance the security of the database server?",
    "choice_a": "Configure the database server to use a static IP address.",
    "choice_b": "Place the database server in a private network and implement a perimeter network.",
    "choice_c": "Disable the firewall on the database server to allow unrestricted access.",
    "choice_d": "Store the database server and web application server on the same public network.",
    "correct_answer": "B",
    "explanation": "Configuring the database server to use a static IP address does not enhance security, as a static IP provides a fixed address to the database server.<br>Disabling the firewall on the database server to allow unrestricted access does not distinguish between authorized and unauthorized database clients.<br>Placing the database and web application servers on the same public network exposes both servers to potential intruders, allowing them to attack the database server directly.<br>Placing the database server in a private network and implementing a perimeter network (also known as a demilitarized zone, or DMZ) is the best approach as it provides an additional layer of security by separating the database server from the public Internet.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      47,
      41,
      42,
      45,
      46
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 72,
    "question": "Housni, a network administrator at a midsize company, is working on improving the database connectivity of a client/server architecture. He wants to ensure the security of the connections and prevent unauthorized access to the database server. Which of the following network components should Housni configure to achieve this objective?",
    "choice_a": "Domain Name System (DNS)",
    "choice_b": "Firewall",
    "choice_c": "Database schema",
    "choice_d": "Dynamic Host Configuration Protocol (DHCP) server",
    "correct_answer": "B",
    "explanation": "Domain Name System (DNS) translates human-readable domain names into their corresponding Internet Protocol (IP) addresses. A database schema refers to the structure of the database and its data structures, not the security of network connections or the prevention of unauthorized access. A Dynamic Host Configuration Protocol (DHCP) server assigns dynamic IP addresses to clients and does not monitor or control network traffic.<br>A firewall is a security device that monitors and controls incoming and outgoing network traffic based on predetermined security rules. By properly setting up firewall configurations, Housni can control and monitor the traffic between clients and the database server, allowing only legitimate requests and blocking potential threats.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      47,
      46,
      41,
      45,
      44
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 73,
    "question": "Suneel is a senior network administrator at a financial services firm that recently acquired a Qlik server for generating reports. He needs to update the configuration for the firewall that protects his Microsoft SQL Server database to allow access from the Qlik server using the default database port. What port does he need to ensure is open between the two servers?",
    "choice_a": "1521",
    "choice_b": "5432",
    "choice_c": "1433",
    "choice_d": "50000",
    "correct_answer": "C",
    "explanation": "The default port for Oracle is 1521, the default for PostgreSQL is 5432, and the default for Db2 is 50000. 1433 is the default port for Microsoft SQL Server.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      47,
      46,
      45,
      44,
      42
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 74,
    "question": "Samar is a database administrator who maintains multiple relational databases in her organization and must understand referential integrity. Which rule requires that when a new record is inserted into a table with a foreign key, the foreign key value must match an existing primary key value in the related table?",
    "choice_a": "The Insert Rule",
    "choice_b": "The Update Rule",
    "choice_c": "The Delete Rule",
    "choice_d": "The Foreign Key Rule",
    "correct_answer": "A",
    "explanation": "The Update, Delete, and Foreign Key Rules do not pertain to inserting new records. The Insert Rule says that when you insert a new record into a table with a foreign key, the foreign key value must match an existing primary key value in the related table.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      43,
      51,
      41,
      37,
      40
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 75,
    "question": "Gerald is a database developer working on a new project. He is responsible for maintaining the quality of the database and ensuring that the data stays consistent. Gerald wants to limit the possibility of duplicate data in a particular column. Which constraint should he apply to the column to achieve this?",
    "choice_a": "Primary key constraint",
    "choice_b": "Check constraint",
    "choice_c": "Foreign key constraint",
    "choice_d": "Unique key constraint",
    "correct_answer": "D",
    "explanation": "A primary key constraint enforces uniqueness on the column(s) that make up the primary key, and its main purpose is to identify individual rows. A check constraint limits the range of values and does not prevent duplicate data in a column. A foreign key constraint enforces a relationship between two tables, ensuring referential integrity. A unique key constraint ensures that each value in a specific column is unique, effectively preventing duplicate data in that column.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      51,
      43,
      48,
      50,
      41
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 76,
    "question": "Madeline is a database administrator who is optimizing the performance of a database. She notices that a query retrieves data from multiple tables using a nested subquery. She wants to improve the query\u2019s performance. What technique should Madeline use to make the query more efficient?",
    "choice_a": "Implement range control using referential integrity.",
    "choice_b": "Modify the query to use a join instead of a nested subquery.",
    "choice_c": "Add a check constraint to the affected columns.",
    "choice_d": "Apply a unique key constraint on the relevant columns.",
    "correct_answer": "B",
    "explanation": "Implementing range control using referential integrity limits the values in a column to a specific range, ensuring that the data remains consistent. Check constraints enforce domain restrictions on a column, such as limiting the range of values. A unique key constraint ensures that each value in a specific column is unique, preventing duplicate data in that column instead of improving the performance of a query retrieving data from multiple tables. Modifying the query to use a join instead of a nested subquery is generally more efficient than using a nested subquery. By using a join, Madeline can improve the performance of the query that retrieves data from multiple tables.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      48,
      49,
      43,
      40,
      50
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 77,
    "question": "Olivia is a database administrator responsible for ensuring the stability and performance of a critical database in the auction industry. She wants to evaluate the database\u2019s performance under extreme conditions to identify potential bottlenecks and weaknesses. What type of testing should Olivia perform?",
    "choice_a": "Regression testing",
    "choice_b": "Negative testing",
    "choice_c": "Stress testing",
    "choice_d": "Unit testing",
    "correct_answer": "C",
    "explanation": "Regression testing re-executes existing tests to ensure that changes do not have unintended negative consequences. Negative testing provides invalid, unexpected, or incorrect inputs to ensure the database can handle such aberrant situations gracefully. Unit testing tests individual components or functions in isolation to ensure they perform as expected. Stress testing evaluates a database\u2019s performance, stability, and reliability under extreme conditions. By intentionally exceeding the target operating capacity of the database, Olivia can identify the system\u2019s breaking point and address potential bottlenecks and weaknesses.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      49,
      48,
      39,
      50,
      51
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 78,
    "question": "Angela, a database administrator, is designing a stress test for her company\u2019s database. She wants to simulate a realistic high-stress condition to identify the database\u2019s maximum sustainable transaction volume and concurrent user capacity. Which of the following is crucial for Angela to ensure her stress test is accurate?",
    "choice_a": "Limit the test data to a small number of customers.",
    "choice_b": "Execute the test in an environment that does not resemble production.",
    "choice_c": "Generate large amounts of synthetic data for the test.",
    "choice_d": "Use invalid SQL queries for the test.",
    "correct_answer": "C",
    "explanation": "Limiting the test data to a small number of customers can lead to inaccurate results due to caching data in RAM. Test environments should closely mimic the production environment to provide a more accurate understanding of how the production system will perform. Using invalid SQL queries falls under the scope of negative testing. Generating large amounts of synthetic data ensures that stress testing accurately reflects real-world scenarios.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      49,
      44,
      39,
      48,
      45
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 79,
    "question": "Samia, a database administrator, is optimizing the performance of her company\u2019s database. She wants to ensure that frequently executed queries retrieve all necessary data directly from an index without accessing the underlying table data. What concept should Samia focus on to improve query performance? Choose the best answer.",
    "choice_a": "Reducing the database\u2019s need to parse queries",
    "choice_b": "Ensuring data mapping consistency",
    "choice_c": "Implementing covered queries",
    "choice_d": "Enforcing data integrity rules",
    "correct_answer": "C",
    "explanation": "Reducing the database\u2019s need to parse queries relates to using bind variables instead of hard-coded parameters in SQL queries. While it improves query consistency and performance, it does not address Samia\u2019s goal of retrieving all necessary data directly from an index.<br>Ensuring data mapping consistency involves mapping data correctly when integrating multiple systems or migrating data from an existing database to a new one. Enforcing data integrity rules involves testing the enforcement of data integrity rules and constraints, such as primary keys, foreign keys, unique constraints, and check constraints.<br>A covered query retrieves the required data directly from an index without accessing the base table data.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      48,
      49,
      43,
      40,
      51
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 80,
    "question": "Ibrahim is a database administrator tasked with ensuring the database configuration\u2019s operational stability. He needs to verify the accuracy, consistency, and completeness of data stored in the database. Which aspect of database validation should Ibrahim focus on to achieve this goal?",
    "choice_a": "Data mapping",
    "choice_b": "Data values",
    "choice_c": "Query validation",
    "choice_d": "Index analysis",
    "correct_answer": "B",
    "explanation": "Data mapping consistently maps data elements to similar data types as data flows between the database and the systems it interacts with. Query validation tests the correctness and performance of SQL queries, stored procedures, and views within the database and connected applications. Index analysis focuses on analyzing and optimizing database indexes to improve query performance. Validating data values involves ensuring the accuracy, consistency, and completeness of data stored in the database.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      51,
      48,
      43,
      49,
      50
    ],
    "source": "180059_Ch04"
  },
  {
    "id": 81,
    "question": "Dillon is a database administrator for an online retail company. His company requires hosting all its data locally, and due to procurement processes, obtaining additional storage hardware can take multiple weeks. The company has just launched a new product line, and he notices an unexpected surge in the data growth rate. Dillon wants to ensure the database operation stays stable by taking preventive action. The database grew from 50 percent to 70 percent of the total storage capacity in a week. Based on the information provided, which of the following should be Dillon\u2019s best course of action?",
    "choice_a": "Set an alert threshold for the database size to 80 percent of the total storage capacity.",
    "choice_b": "Ignore the surge since the storage utilization is within normal parameters.",
    "choice_c": "Start the storage hardware procurement process and closely monitor the growth rate.",
    "choice_d": "Set an alert threshold for the database size to 90 percent of the total storage capacity.",
    "correct_answer": "C",
    "explanation": "Setting an alert threshold at 80% or 90% are incorrect because setting the threshold to 80 or 90 percent might not provide enough lead time to procure and install additional storage hardware. Ignoring the surge is also incorrect because, although 70 percent utilization might be within normal parameters, the unexpected surge in data suggests that the database could quickly reach its capacity, potentially leading to operational issues. Starting the procurement process and closely monitoring the growth rate is the most prudent course of action since the database grew rapidly in only a week.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      53,
      55,
      67,
      52,
      57
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 82,
    "question": "Vijay is a database administrator at a large manufacturing firm. He is responsible for maintaining the health and reliability of the organization\u2019s databases. After observing a sudden increase in CPU utilization during peak load, Vijay allocates additional CPU to the database server. The CPU utilization normalizes after this change. What is the importance of establishing a baseline configuration in this scenario? Choose the best answer.",
    "choice_a": "It helps identify whether the change in CPU utilization was normal or due to an unexpected event.",
    "choice_b": "It assists in forecasting the database\u2019s storage requirements for the next fiscal year.",
    "choice_c": "It provides a reference point for comparing system performance before and after the change.",
    "choice_d": "Vijay can log job completion details such as start and end times, duration, and record count.",
    "correct_answer": "A",
    "explanation": "While baselines help with forecasting storage requirements, the original scenario does not mention storage. The question does not mention batch processing inferred in logging job completion details. While providing a reference point is true, identifying whether the CPU change was normal or unexpected describes the real value in having a baseline so Vijay can compare the spike against past database behavior.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      55,
      54,
      67,
      52,
      57
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 83,
    "question": "Kelly is a database administrator trying to predict the future resource needs of her organization\u2019s database. After identifying system usage and performance trends, she notices that the database has grown by 100 GB monthly over several months. She expects this growth to continue linearly. Which of the following concepts is Kelly most likely utilizing for this purpose?",
    "choice_a": "Database replication",
    "choice_b": "Monitoring job completion",
    "choice_c": "Baseline configuration/trending",
    "choice_d": "Database backups",
    "correct_answer": "C",
    "explanation": "Database replication is incorrect because database replication concerns availability and redundancy rather than capacity planning or predicting future resource needs. Monitoring job completion is incorrect as it describes tracking the success or failure of database jobs, which doesn\u2019t involve predicting future resource needs or identifying usage trends. Database backups is incorrect because backups aren\u2019t the source of this growth.<br>Kelly is using baseline configuration and trending to identify and predict storage consumption, making baseline configuration/trending the correct choice. Observing database growth at 100 GB/month helps her plan for future storage capacity needs effectively.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      55,
      53,
      67,
      57,
      54
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 84,
    "question": "Giancarlo is a database administrator for a large company. His team routinely runs batch extract processes, backups, and data quality validation scripts. Giancarlo has set up a system that logs details about these jobs, such as start and end times, duration, and the number of records loaded or manipulated. However, Giancarlo only configures notifications to alert him when jobs fail, not when they complete successfully. What best describes the approach Giancarlo is using? Choose the best answer.",
    "choice_a": "System logs",
    "choice_b": "Database replication",
    "choice_c": "Baseline configuration/trending",
    "choice_d": "Management-by-exception",
    "correct_answer": "D",
    "explanation": "Database replication is incorrect since database replication improves database availability. Baseline configuration/trending is incorrect as it establishes a standard level of resource utilization to compare against future utilization. While Giancarlo is logging job details, system logs is not the best answer. This scenario describes a management-by-exception approach, as Giancarlo is crafting notifications only in a failure situation.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      52,
      56,
      58,
      57,
      55
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 85,
    "question": "Michela is a database administrator at a healthcare company. To enhance the database\u2019s availability in case of failure, Michela has set up a secondary database where all the changes made to the primary database get replicated. What strategy is Michela using?",
    "choice_a": "Baseline configuration/trending",
    "choice_b": "Database backups",
    "choice_c": "Database replication",
    "choice_d": "Monitoring job completion/failure",
    "correct_answer": "C",
    "explanation": "Baseline configuration/trending is incorrect as it establishes a standard level of resource utilization to compare against future utilization. Monitoring job completion/failure is incorrect, as monitoring job completion/failure involves checking the status of various database jobs and setting alerts for when jobs fail. While database backups are vital to data protection, database backups is incorrect since backups are offline copies of the database. In the scenario, Michela is creating a live copy of the database, which describes replication, making database replication the best option.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      56,
      55,
      53,
      67,
      66
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 86,
    "question": "Gianni works for a large petrochemical company and has observed a sudden increase in CPU utilization on his database server during peak load times. The database, which historically uses 70 percent of CPU during peak load, is now consistently using 90 percent. Gianni has established a baseline configuration for resource utilization. What could the change in CPU utilization indicate?",
    "choice_a": "There is an expected increase in data volume.",
    "choice_b": "There is a missing index in the database.",
    "choice_c": "A set of queries is performing poorly.",
    "choice_d": "All of the above.",
    "correct_answer": "D",
    "explanation": "The change in CPU utilization could indicate any or all of the options provided. An expected increase in data volume could lead to higher CPU utilization. A missing index in the database could also result in higher CPU utilization as the database would need to scan more data. Similarly, a poorly performing set of queries could cause an increase in CPU utilization. Therefore, any of these changes could be responsible for increased CPU utilization.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      54,
      55,
      63,
      64,
      67
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 87,
    "question": "Melody is troubleshooting unexpectedly high CPU utilization in her database. Examining the explain plan for one of the top queries, she sees it performs full table scans. What is the most likely maintenance task Melody needs to do next?",
    "choice_a": "Patch management",
    "choice_b": "Database integrity checks",
    "choice_c": "Query optimization",
    "choice_d": "Load balancing",
    "correct_answer": "C",
    "explanation": "Database integrity checks is incorrect as explain plans have nothing to do with validating data integrity. Load balancing is incorrect because load balancing involves distributing work across multiple servers. While a patch could impact how the optimizer executes a query, query optimization best describes what Melody needs to do next.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      63,
      64,
      54,
      57,
      55
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 88,
    "question": "Emily works for a pharmaceutical company and is making plans for an upcoming database release. She wants to ensure that the release is successful and minimizes disruption. Which of the following is essential for Emily to consider during the planning phase of the release?",
    "choice_a": "Fixing data in the production environment",
    "choice_b": "Determining the size and scope of the release",
    "choice_c": "Testing the changes included in the release",
    "choice_d": "Allocating sufficient time for database refresh",
    "correct_answer": "B",
    "explanation": "While fixing data in the production environment is important, it is not directly related to a release\u2019s planning phase, making fixing data in the production environment incorrect. Not all database releases require a database refresh, making allocating time for a database refresh incorrect. While testing the changes included in the release helps minimize downtime, determining the size and scope of the release during planning helps determine how to implement the change and impacts what needs testing, making size and scope the best option.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      66,
      67,
      68,
      55,
      73
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 89,
    "question": "Germana is responsible for the capacity planning of her organization\u2019s database environment. Which of the following considerations should she take into account during capacity planning?",
    "choice_a": "Implementing changes included in a database release",
    "choice_b": "Estimating future storage, computing resources, and network bandwidth needs",
    "choice_c": "Testing the changes to ensure their success",
    "choice_d": "Assessing the impacts of proposed changes through the change advisory board (CAB)",
    "correct_answer": "B",
    "explanation": "Germana needs to estimate the future storage, computing resources, and network bandwidth needs during capacity planning based on the organization\u2019s current operations, making estimating future needs the best choice. While a database release can impact capacity requirements, identifying its impact on capacity requirements is done during planning, making implementing changes incorrect. Testing changes is incorrect, as it relates to validating functionality, not capacity planning. While changes need CAB approval, it is not directly related to capacity planning.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      67,
      55,
      53,
      54,
      57
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 90,
    "question": "Mahima is a data systems professional at an online retail business with a massive database handling thousands of daily transactions. She has noticed a slowdown in the database performance and suspects it might be due to an issue with a data issue. Which of the following best describes what Mahima should do to investigate and potentially resolve this issue?",
    "choice_a": "Implement a new security patch to address potential vulnerabilities.",
    "choice_b": "Check the system\u2019s audit logs to identify any suspicious activity.",
    "choice_c": "Execute database integrity checks to ensure the correctness and consistency of data.",
    "choice_d": "Schedule an immediate system update to improve overall performance.",
    "correct_answer": "C",
    "explanation": "The correct answer is executing database integrity checks. If Mahima suspects a data problem, she should first run database integrity checks. These checks verify referential, domain, and entity integrity, ensuring that relationships between tables are valid, column values conform to business rules and column definitions, and tables have primary keys. Nothing in the scenario implies a security vulnerability, making implementing a security patch incorrect. Checking audit logs would be useful if Mahima suspected a security breach or unauthorized access. Scheduling a system update may impact overall performance but does not address a specific data issue.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      61,
      62,
      63,
      54,
      57
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 91,
    "question": "Anitej is a data systems professional at a large healthcare company. Because of recent legislative changes, the company must comply with new data privacy laws. As part of this process, Anitej must update the database to accommodate a new feature allowing patients to request their data's removal. This new feature requires adding a data_removal_request field to an existing Patient table. Which of the following tools can Anitej use to generate the appropriate DDL and update the ERD for the database?",
    "choice_a": "Microsoft Word",
    "choice_b": "Google Sheets",
    "choice_c": "Lucidchart",
    "choice_d": "Oracle SQL Developer Data Modeler",
    "correct_answer": "D",
    "explanation": "The correct answer is option D, Oracle SQL Developer Data Modeler, which Anitej can use to update an ERD and generate differential DDL. Microsoft Word and Google Schees are incorrect because Word and Sheets are not diagramming tools. While Anitej can maintain an ERD and generate DDL using Lucidchart, Lucidchart cannot generate differential DDL, Oracle SQL Developer Data Modeler.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      72,
      76,
      77,
      71,
      75
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 92,
    "question": "Jane is a data systems analyst working for a startup company. The startup is small, with a modest database consisting of just a few tables. They don't have extensive resources to purchase advanced data modeling or diagramming tools, but they need to maintain a data dictionary for their database. Given these conditions, what tool would best suit Jane\u2019s needs for maintaining a data dictionary?",
    "choice_a": "Oracle SQL Developer Data Modeler",
    "choice_b": "DbSchema",
    "choice_c": "Google Docs",
    "choice_d": "Erwin",
    "correct_answer": "C",
    "explanation": "Of the options listed, Google Docs would be the most appropriate tool for maintaining a small data dictionary. Oracle SQL Developer Data Modeler, DbSchema, and Erwin are best suited for maintaining ERDs.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      71,
      75,
      76,
      72,
      61
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 93,
    "question": "Meredith is a data systems analyst at a multinational company that employs the Unified Modeling Language (UML) for creating system diagrams, including visual representations of their database structures and relationships. She needs to update a UML class diagram to reflect the addition of five new database tables. Which of the following tools would be most appropriate for Meredith\u2019s task?",
    "choice_a": "Microsoft Word",
    "choice_b": "Google Sheets",
    "choice_c": "DbSchema",
    "choice_d": "Lucidchart",
    "correct_answer": "D",
    "explanation": "Lucidchart is a diagramming tool that supports Unified Modeling Language (UML) diagrams, making it the best choice for Meredith\u2019s needs. Microsoft Word is a word processor, Google Sheets is a spreadsheet tool, and DbSchema is a data modeling tool, none of which directly support modeling in UML.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      72,
      71,
      76,
      75,
      77
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 94,
    "question": "Alex is the newly hired database administrator at a small healthcare company and is reviewing the SOPs as part of his onboarding. In the context of Alex\u2019s healthcare company, which section of the SOPs should have the highest priority to align with the nature of the industry and regulatory requirements? Choose the best answer.",
    "choice_a": "System Architecture",
    "choice_b": "Security Management",
    "choice_c": "Data Backup and Restoration",
    "choice_d": "Performance Tuning",
    "correct_answer": "B",
    "explanation": "In the healthcare industry, protecting sensitive patient data is a top priority due to laws such as the Health Insurance Portability and Accountability Act (HIPAA) in the United States. Therefore, the correct answer is option B. While understanding the system architecture is important for a new database administrator, other priorities take precedence in the context of regulatory requirements, making system architecture incorrect. Data protection is vital for any business, but less important than Security Management, making data backup and restoration incorrect. Performance tuning is incorrect, as performance has nothing to do with regulatory requirements.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      70,
      73,
      74,
      60,
      58
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 95,
    "question": "Laura works as a data systems analyst for an international financial corporation. She is responsible for working with a consulting firm to document how her company complies with industry standards and governmental regulations. Which of her company\u2019s SOPs should Laura review to ensure she doesn\u2019t miss something crucial? Choose the best option.",
    "choice_a": "System Updates and Upgrades",
    "choice_b": "Data Quality",
    "choice_c": "Audit",
    "choice_d": "Change Management",
    "correct_answer": "C",
    "explanation": "Auditing procedures are critical in documenting compliance, making it the best answer. Although System Updates and Upgrades are crucial to keeping a database current, these activities don\u2019t directly address regulatory considerations. Data quality is incorrect, as data quality is only partially related to compliance. Not all change management procedures are crucial to compliance, making change management incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      70,
      74,
      73,
      58,
      68
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 96,
    "question": "Sandra is a data systems analyst at a healthcare company. Recently, her company decided to start a patient wellness program that necessitates tracking new data elements like patient wellness program numbers and wellness point totals. Sandra has concluded that these data elements are patient attributes and must add them to the existing Patient table. She also realized the importance of enforcing uniqueness on the wellness program number to avoid duplicates. Which SQL statements should Sandra use to perform these tasks?",
    "choice_a": "ALTER TABLE patient ADD COLUMN wellness_pgm_id INTEGER;<br>ALTER TABLE patient ADD CONSTRAINT uc_wellness_pgm_id UNIQUE(wellness_pgm_id);",
    "choice_b": "ALTER TABLE patient ADD wellness_pgm_id INTEGER;<br>ALTER TABLE patient ADD CONSTRAINT UNIQUE(wellness_pgm_id);",
    "choice_c": "ALTER TABLE patient ADD COLUMN wellness_pgm_id INTEGER;<br>ALTER TABLE patient ADD CONSTRAINT wellness_pgm_id UNIQUE;",
    "choice_d": "ALTER TABLE patient ADD wellness_pgm_id INTEGER;<br>ALTER TABLE patient ADD CONSTRAINT uc_wellness_pgm_id UNIQUE;",
    "correct_answer": "A",
    "explanation": "The ALTER TABLE command adds a new column to an existing table, and the ADD CONSTRAINT command applies the unique constraint. Option B is incorrect because it lacks the COLUMN keyword when attempting to add a new column, and the UNIQUE keyword is incorrect\u2014the column name should be inside the parentheses. Option C is incorrect as the UNIQUE constraint is not correctly defined. The unique constraint name is missing after the ADD CONSTRAINT keyword, and the column name should be inside the parentheses after UNIQUE. Option D is incorrect because it lacks the COLUMN keyword when attempting to add a new column.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      77,
      78,
      71,
      72,
      76
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 97,
    "question": "Jackson is on the analytics team for an automotive company. One of the reports he is working on requires data from 18 tables. No matter how much he optimizes his query, running takes at least 8 minutes, which is too long for users to wait. Talking with business leaders, Jackson realizes that the information in the result set can be up to 30 minutes old without impacting business decisions. What should Jackson do to meet this requirement? Choose the best option.",
    "choice_a": "Create an index.",
    "choice_b": "Create a view.",
    "choice_c": "Create a materialized view.",
    "choice_d": "Remove data to reduce the number of joins.",
    "correct_answer": "C",
    "explanation": "Configuring a materialized view that refreshes every 30 minutes would satisfy Jackson\u2019s need, making option C the best choice. Jackson has already optimized his query, making creating an index an invalid choice. A standard view wouldn\u2019t address the performance issue. Removing data could not be done without approval, making reducing the number of joins incorrect.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      79,
      63,
      64,
      69,
      67
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 98,
    "question": "Lisa is a data systems analyst working for an e-commerce company that recently merged with another similar company. As a result of the merger, the company has duplicate data in its customer database. Lisa needs to resolve this data redundancy and improve data sharing between different systems. Which approach should Lisa consider to resolve these issues effectively?",
    "choice_a": "She should delete all duplicated data manually without a standardized process.",
    "choice_b": "She should keep the databases separate and manage data redundancy individually for each database.",
    "choice_c": "She should implement a duplicate resolution process and consolidate functionality into an API layer.",
    "choice_d": "She should give users a visual warning about potential data duplication.",
    "correct_answer": "C",
    "explanation": "The correct answer is C. Lisa should implement a duplicate resolution process to identify and remove duplicate records from the customer database. Consolidating functionality into an API layer will help improve data sharing and SQL consistency across multiple systems. Manually deleting duplicated data is incorrect because manually deleting duplicates isn\u2019t scalable or reliable. Keeping separate databases is incorrect, as keeping databases separate without a plan to manage redundancy doesn\u2019t address the problem. Giving users a visual warning is incorrect because giving users a visual warning does not address the underlying data duplication.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      79,
      80,
      61,
      62,
      71
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 99,
    "question": "Miguel is a data analyst at a large university. To help offset the cost of education, many students at the university also have work-study jobs. Currently, the university maintains separate databases for student and employee information, causing data redundancy. Miguel needs to resolve this redundancy and improve data sharing. Which approach should Miguel adopt to tackle these issues?",
    "choice_a": "He should merge the two databases without considering the data schema.",
    "choice_b": "He should invest in a single database with multiple schemas and employ an API layer for data access and manipulation.",
    "choice_c": "He should manually update each student\u2019s data across both databases whenever changes occur.",
    "choice_d": "He should delete one of the databases and only maintain a single source of data.",
    "correct_answer": "B",
    "explanation": "By investing in a single database with multiple schemas, Miguel can better manage and reduce data redundancy. This approach allows for a shared schema with common attributes like name and address, leaving student- and employee-specific elements in their own schemas. An API layer ensures consistent and controlled access to the data across different systems, thereby improving data sharing and SQL consistency. Merging databases is incorrect because merging the two databases without considering the schema design leads to additional data inconsistency and could worsen redundancy. Manually updating data is incorrect because manually updating each student\u2019s data across both databases is tedious, time-consuming, inefficient, and prone to error. Deleting a database is incorrect because deleting one of the databases doesn\u2019t solve the problem, since the university still needs to maintain student- and employee-specific data.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      80,
      79,
      71,
      76,
      78
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 100,
    "question": "Maddie is a data systems analyst for a motorcycle manufacturer. Product development is working on creating a new 1000 cc adventure touring motorcycle. The product owner wants to compare the features and specifications of existing motorcycles of similar displacement to better understand the competitive landscape. What can Maddie do to help product development? Choose the best answer.",
    "choice_a": "Modify data about her company's existing motorcycles.",
    "choice_b": "Create a view with details about her company's. motorcycles.",
    "choice_c": "Create a new table to store information about the competition.",
    "choice_d": "Create a new data set using publicly available information about competitor\u2019s products.",
    "correct_answer": "D",
    "explanation": "Modifying data or creating a view for the existing motorcycles are incorrect as the product owner is looking for information about the competition. While she may need a new table to store the information she needs to gather, creating a new data set using publicly available information best describes how Maddie can help collect the information product management wants.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      71,
      76,
      78,
      79,
      80
    ],
    "source": "180059_Ch05"
  },
  {
    "id": 101,
    "question": "Victoria\u2019s organization has a disconnect between the human resources function and the information security function. As a result, employee transfers are not being properly handled. What is the greatest security risk resulting from this situation?",
    "choice_a": "Privilege escalation",
    "choice_b": "Separation of duties",
    "choice_c": "Privilege creep",
    "choice_d": "Two-person control",
    "correct_answer": "C",
    "explanation": "Privilege creep occurs when an employee transfers within the organization and does not have their old privileges revoked. Privilege creep may occur when transfers are not properly processed and, if left unchecked, violates the principle of least privilege.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      103,
      83,
      85,
      82,
      91
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 102,
    "question": "Which of these roles is assigned to an information technology professional who implements technical controls to further data governance objectives?",
    "choice_a": "Data owner",
    "choice_b": "Data custodian",
    "choice_c": "Data janitor",
    "choice_d": "Data steward",
    "correct_answer": "B",
    "explanation": "A data owner is a senior leader over a functional unit, a data steward is responsible for looking after an organization\u2019s data, and a data janitor is not a valid role.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      82,
      84,
      85,
      86,
      106
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 103,
    "question": "Eve is classifying data that is part of the interface between her organization and their health insurance provider. One of the fields in the data set is Social Security number. What data classification is most appropriate?",
    "choice_a": "Public",
    "choice_b": "Internal",
    "choice_c": "Sensitive",
    "choice_d": "Highly Sensitive",
    "correct_answer": "D",
    "explanation": "Public applies to data intended for public consumption, internal applies to data for use within an organization, sensitive applies to data that is for limited use within an organization, and highly sensitive data is reserved for restricted use.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      97,
      98,
      99,
      84,
      94
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 104,
    "question": "Silas works in communications and has been asked to classify the assets on the organization\u2019s externally-facing website. What data classification is most appropriate?",
    "choice_a": "Public",
    "choice_b": "Internal",
    "choice_c": "Sensitive",
    "choice_d": "Highly Sensitive",
    "correct_answer": "A",
    "explanation": "Public applies to data intended for public consumption, internal applies to data for use within an organization, sensitive applies to data that is for limited use within an organization, and highly sensitive data is reserved for restricted use.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      97,
      84,
      98,
      101,
      82
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 105,
    "question": "Clarence is developing a data access strategy for his organization which consists of 150 people across 5 groups, with 3 roles in each group. How many roles should Clarence expect to create to appropriately safeguard the data?",
    "choice_a": "3",
    "choice_b": "5",
    "choice_c": "15",
    "choice_d": "150",
    "correct_answer": "C",
    "explanation": "With role-based access, Clarence should create a data access role that allows each person in a group to perform their job function. Five groups with three roles per group comes out at fifteen roles.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      87,
      83,
      84,
      85,
      103
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 106,
    "question": "Zeke wants to protect his organization\u2019s data. What precautions should he take for cloud-based storage?",
    "choice_a": "Encryption at rest",
    "choice_b": "Encryption in transit",
    "choice_c": "Encryption at rest and in transit",
    "choice_d": "User-based encryption",
    "correct_answer": "C",
    "explanation": "To keep his organizational data secure, Zeke needs to encrypt his data at rest as well as during transmission.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      92,
      97,
      84,
      95,
      101
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 107,
    "question": "Maxine is completing some new-hire paperwork using a form on the web. What should she do to ensure the connection is encrypted?",
    "choice_a": "Use HTTP.",
    "choice_b": "Use the Chrome browser.",
    "choice_c": "Check for HTTPS in the address bar.",
    "choice_d": "Check that the padlock icon is closed.",
    "correct_answer": "D",
    "explanation": "Maxine wants to ensure she is using HTTPS, which will appear in the browser's address bar at the beginning of the URL.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      92,
      96,
      121,
      115,
      116
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 108,
    "question": "Zaid needs to share medical imagery data with a partner who is developing a machine learning model to identify cancer. What does Zaid need to do to ensure privacy? Choose the best answer.",
    "choice_a": "De-identify the data.",
    "choice_b": "Sort the data in random order.",
    "choice_c": "Encrypt the data.",
    "choice_d": "Aggregate the data.",
    "correct_answer": "A",
    "explanation": "While aggregation is an option, it\u2019s not viable for individual images. While the data need to be encrypted, especially in transit, it is more important to de-identify. The sort order does not matter.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      93,
      99,
      98,
      92,
      96
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 109,
    "question": "Fred has two de-identified data sets. The first contains medical treatment data, and the other contains biographic information. The zip code, sex, and birth date exist in both data sets. Is personal privacy at risk? Choose the best answer.",
    "choice_a": "No, the data is de-identified.",
    "choice_b": "No, the data sets are separate.",
    "choice_c": "Yes, reidentification is possible using zip code, sex, and birth date.",
    "choice_d": "Yes, reidentification is possible because one of the data sets has biographic information.",
    "correct_answer": "C",
    "explanation": "The point of this question is that it is possible, using zip code, sex, and birth date, to re-identify individuals making personal privacy at risk.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      98,
      93,
      99,
      95,
      97
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 110,
    "question": "Which of the following is not considered PII?",
    "choice_a": "Passport number",
    "choice_b": "Favorite food",
    "choice_c": "Address",
    "choice_d": "Credit card number",
    "correct_answer": "B",
    "explanation": "Passport number, credit card number, and address are all considered PII.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      98,
      99,
      100,
      101,
      95
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 111,
    "question": "Which of the following is considered Sensitive Authentication Data by the PCI DSS?",
    "choice_a": "PIN",
    "choice_b": "Name",
    "choice_c": "Account number",
    "choice_d": "Expiration Date",
    "correct_answer": "A",
    "explanation": "Name, account number, and expiration date are all classified as Cardholder Data under PCI DSS. Personal identification numbers (PINs) fall under the more restrictive category of Sensitive Authentication Data.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      100,
      89,
      97,
      94,
      101
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 112,
    "question": "Tom is building a multifactor authentication system that requires users to enter a passcode and then verifies that their face matches a photo stored in the system. What two factors is this system using?",
    "choice_a": "Something you know and something you have",
    "choice_b": "Somewhere you are and something you have",
    "choice_c": "Something you have and something you are",
    "choice_d": "Something you know and something you are",
    "correct_answer": "D",
    "explanation": "A passcode is an example of a knowledge-based authentication technique, or \u201csomething you know.\u201d<br>Facial recognition technology is an example of a biometric authentication technique, or \u201csomething you are.\u201d.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      89,
      88,
      90,
      91,
      110
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 113,
    "question": "Gary is logging into a system and is providing his fingerprint to gain access. What step of the IAM process is he performing?",
    "choice_a": "Identification",
    "choice_b": "Authorization",
    "choice_c": "Authentication",
    "choice_d": "Accounting",
    "correct_answer": "C",
    "explanation": "Gary is proving his identity with his fingerprint, a biometric mechanism. Steps that prove your identity are examples of authentication techniques.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      88,
      89,
      108,
      90,
      106
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 114,
    "question": "Gwen recently discovered that sensitive API keys were located in a public code repository. What type of audit would detect this issue?",
    "choice_a": "Expired account audit",
    "choice_b": "Connection request audit",
    "choice_c": "SQL code audit",
    "choice_d": "Credential storage audit",
    "correct_answer": "D",
    "explanation": "A credential storage audit focuses on the security of stored sensitive information, such as passwords and API keys. In this scenario, Gwen discovered that sensitive API keys were located in a public code repository.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      106,
      105,
      95,
      103,
      104
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 115,
    "question": "Mike is worried that Social Security numbers are used throughout his organization, and he would like to discover cases where they were previously undetected. Which one of the following data loss prevention mechanisms would best meet his needs?",
    "choice_a": "Host-based DLP",
    "choice_b": "Network-based DLP",
    "choice_c": "Pattern matching DLP",
    "choice_d": "Watermarking DLP",
    "correct_answer": "C",
    "explanation": "Mike should use pattern matching to meet this need. Pattern matching does not depend upon knowing where sensitive data is stored in advance and is ideal for detecting previously undetected cases of sensitive information storage. Watermarking is only useful when you are able to identify sensitive documents in advance. The trick to answering this question correctly is realizing that it is asking about the mechanism of action and not the environment (network-based or host-based).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      94,
      95,
      98,
      97,
      92
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 116,
    "question": "Which of the following best describes the purpose of data masking in a data security framework?",
    "choice_a": "To encrypt data for storage in a secure database",
    "choice_b": "To prevent unauthorized access to sensitive data by making it unreadable",
    "choice_c": "To make a copy of production data for use in non-production environments",
    "choice_d": "To securely destroy data when it is no longer needed",
    "correct_answer": "B",
    "explanation": "Data masking is a technique used to protect sensitive information by obscuring it. Data masking does not use encryption but instead substitutes nonsensitive values to take the place of sensitive ones. Data masking does not copy or destroy data.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      93,
      92,
      97,
      94,
      98
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 117,
    "question": "Brian works for a company that handles the personal information of European Union residents. What law likely applies to this data?",
    "choice_a": "GDPR",
    "choice_b": "HIPAA",
    "choice_c": "GLBA",
    "choice_d": "PCI DSS",
    "correct_answer": "A",
    "explanation": "The European Union\u2019s General Data Protection Regulation (GDPR) applies to the personally identifiable information of European Union residents. The Health Insurance Portability and Accountability Act (HIPAA) applies to protected health information (PHI) in the United States. The Gramm Leach Bliley Act (GLBA) applies to personal financial information in the United States. PCI DSS is a private regulation, not a law, and it only applies to credit and debit card data, which is not mentioned in this scenario.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      102,
      101,
      98,
      99,
      100
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 118,
    "question": "Andy is attempting to change his password and has created the following long password:<br>p7djkqnr2LAD <br>He receives an error message that he must use a symbol in his password. What password policy is he failing to meet?",
    "choice_a": "Password length",
    "choice_b": "Password history",
    "choice_c": "Password complexity",
    "choice_d": "Password reuse",
    "correct_answer": "C",
    "explanation": "This is an example of a password complexity requirement. The message is requiring that Andy use a symbol in his password, and password complexity requirements require the use of different character types.<br>There is no indication that Andy is attempting to reuse an old password that would violate a password history requirement or use a password from another site that would violate a password reuse requirement. There is also no indication that his password is too short and does not meet the password length requirements.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      90,
      89,
      91,
      88,
      106
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 119,
    "question": "You recently learned that a website belonging to one of your competitors was breached and you are concerned that users with accounts on both sites will have their passwords compromised on your site as well. Which one of the following password policies would best protect against this risk?",
    "choice_a": "Password reuse",
    "choice_b": "Password complexity",
    "choice_c": "Password length",
    "choice_d": "Password history",
    "correct_answer": "A",
    "explanation": "The primary risk here is that some of your customers are using the same password on your competitor\u2019s site and your site. If the breach compromised passwords, the attacker would be able to use credentials from the other site to access accounts on your site. A password reuse policy would protect against this risk.<br>Password length and complexity requirements ensure that users create strong passwords, but the strength of the password is not in question here. If the attacker is able to obtain the passwords from another site, it does not matter how strong they are.<br>Password history requirements may be of some use in this situation because they would prevent a user from reusing the compromised password at a later date, but that is not the primary threat here. The major risk is that an account will be compromised now because it shares a password with an account on the compromised site.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      90,
      122,
      89,
      101,
      88
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 120,
    "question": "Renee is concerned that unauthorized applications may be retrieving information from her database. What type of audit would detect this issue?",
    "choice_a": "Expired account audit",
    "choice_b": "Connection request audit",
    "choice_c": "SQL code audit",
    "choice_d": "Credential storage audit",
    "correct_answer": "B",
    "explanation": "A connection request audit is the best fit for Renee\u2019s concern because it focuses on tracking and reviewing the incoming requests made to the database. By conducting a connection request audit, Renee can determine if any unauthorized applications have been accessing her database and gather information to help secure it.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      106,
      104,
      94,
      103,
      105
    ],
    "source": "180059_Ch06"
  },
  {
    "id": 121,
    "question": "Helen would like to configure her organization\u2019s switches so that they do not allow systems connected to a switch to spoof MAC addresses. Which one of the following features would be helpful in this configuration?",
    "choice_a": "Loop protection",
    "choice_b": "Port security",
    "choice_c": "Flood guard",
    "choice_d": "Traffic encryption",
    "correct_answer": "B",
    "explanation": "Port security restricts the number of unique MAC addresses that may originate from a single switch port. It is commonly used to prevent someone from unplugging an authorized device from the network and connecting an unauthorized device but may also be used to prevent existing devices from spoofing MAC addresses of other devices.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      113,
      114,
      111,
      112,
      88
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 122,
    "question": "Madhuri wants to implement a camera system but is concerned about the amount of storage space that the video recordings will require. What technology can help with this?",
    "choice_a": "Infrared cameras",
    "choice_b": "Facial recognition",
    "choice_c": "Motion detection",
    "choice_d": "PTZ",
    "correct_answer": "C",
    "explanation": "Motion-detecting cameras can be used to help conserve storage space for video by only recording when motion is detected. In low-usage spaces like data centers, this means recording will only occur occasionally. In more heavily used areas, the impact on total space used will be smaller but can still be meaningful, particularly after business hours. Infrared cameras, facial recognition, and the ability to pan, tilt, and zoom (PTZ) a camera are important features but do not help to conserve storage space.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      110,
      109,
      95,
      97,
      82
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 123,
    "question": "What factor is a major reason why organizations do not use security guards?",
    "choice_a": "Reliability",
    "choice_b": "Training",
    "choice_c": "Cost",
    "choice_d": "Social engineering",
    "correct_answer": "C",
    "explanation": "Security guards can be one of the costliest physical security controls over time, making the cost of guards one of the most important deciding factors guiding when and where they will be employed. Reliability, training, and the potential for social engineering are all possible issues with security guards, but they are not the major driver in the decision process.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      110,
      108,
      107,
      113,
      106
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 124,
    "question": "Which one of the following approaches, when feasible, is the most effective way to defeat injection attacks?",
    "choice_a": "Browser-based input validation",
    "choice_b": "Input allow-listing",
    "choice_c": "Input deny-listing",
    "choice_d": "Signature detection",
    "correct_answer": "B",
    "explanation": "Input allow-listing approaches define the specific input type or range that users may provide. When developers can write clear business rules defining allowable user input, allow-listing is definitely the most effective way to prevent injection attacks.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      116,
      115,
      117,
      105,
      106
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 125,
    "question": "Examine the following network diagram. What is the most appropriate location for a web application firewall (WAF) on this network?<img src=\"/question_assets/DataSys+/c07uf001.png\"/>",
    "choice_a": "Location A",
    "choice_b": "Location B",
    "choice_c": "Location C",
    "choice_d": "Location D",
    "correct_answer": "D",
    "explanation": "Web application firewalls must be placed in front of web servers. This requirement rules out location C as an option. The next consideration is placing the WAF so that it can filter all traffic headed for the web server but sees a minimum amount of extraneous traffic. This makes location D the best option for placing a WAF.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      111,
      116,
      112,
      113,
      118
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 126,
    "question": "Joe is examining the logs for his web server and discovers that a user sent input to a web application that contained the string <code>WAITFOR</code>. What type of attack was the user likely attempting?",
    "choice_a": "Timing-based SQL injection",
    "choice_b": "HTML injection",
    "choice_c": "Cross-site scripting",
    "choice_d": "Content-based SQL injection",
    "correct_answer": "A",
    "explanation": "The use of the SQL <code>WAITFOR</code> command is a signature characteristic of a timing-based SQL injection attack.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      115,
      116,
      118,
      120,
      119
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 127,
    "question": "Which one of the following network zones is usually the most appropriate location for a database server?",
    "choice_a": "Internal network",
    "choice_b": "DMZ",
    "choice_c": "Internet",
    "choice_d": "Screened subnet",
    "correct_answer": "A",
    "explanation": "Database servers should be accessible only to internal systems and users, so they belong on the internal network. Database servers should not be accessible to the general public and, therefore, they should not be placed in a DMZ. Screened subnet is simply another name for the DMZ. The Internet zone is completely unprotected by the firewall and is, therefore, also not appropriate for a database server.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      111,
      112,
      114,
      83,
      85
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 128,
    "question": "What type of fire-suppression system dispenses water using only the specific sprinkler heads that are activated by a fire?",
    "choice_a": "Dry pipe",
    "choice_b": "Wet pipe",
    "choice_c": "Pre-action",
    "choice_d": "Deluge",
    "correct_answer": "C",
    "explanation": "Pre-action systems fill when a potential fire is detected and then release at specific sprinkler heads as they are activated by heat. Dry pipe, wet pipe, and deluge systems all release water from all sprinkler heads when the system is activated.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      107,
      109,
      110,
      108,
      106
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 129,
    "question": "Your data center currently requires that employees scan their identification cards when entering the facility. You would like to upgrade the system to use multifactor authentication with a biometric access control. Which one of the following approaches would best meet this need?",
    "choice_a": "PIN",
    "choice_b": "Smartphone app",
    "choice_c": "Fingerprint scan",
    "choice_d": "Password",
    "correct_answer": "C",
    "explanation": "Fingerprint scans are an example of biometric authentication (\u201csomething you are\u201d) and would complement the use of an identification card (a \u201csomething you have\u201d factor) to provide multifactor authentication. Using a PIN or password (\u201csomething you know\u201d) would also provide multifactor authentication but they are not biometric. Using a smartphone app would not provide multifactor authentication because, like the ID card, it is also an example of \u201csomething you have.\u201d.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      89,
      108,
      107,
      88,
      110
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 130,
    "question": "Which one of the following statements about data center environmental controls is incorrect?",
    "choice_a": "Servers in different rows should be lined up facing in the same direction.",
    "choice_b": "Temperatures should remain below 80.6 degrees Fahrenheit.",
    "choice_c": "Temperatures should remain above 64.4 degrees Fahrenheit.",
    "choice_d": "An appropriate dew point would be 45.5 degrees Fahrenheit.",
    "correct_answer": "A",
    "explanation": "Data centers design facilities around the use of hot aisles and cold aisles. This approach allows data centers to more efficiently house servers and other devices that generate large amounts of heat and require cool air intake. A hot aisle/cold aisle design places air intakes and exhausts on alternating aisles to ensure proper airflow, allowing data center designers to know where to provide cool air and where exhaust needs to be handled. The temperature and dew-point values provided in other answer choices all fit within the acceptable ranges provided by ASHRAE (temperature between 64.4\u201380.6 degrees Fahrenheit and dew point between 41.9\u201350.0 degrees Fahrenheit).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      109,
      107,
      110,
      106,
      102
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 131,
    "question": "Vivian is investigating a website outage that brought down her company\u2019s e-commerce platform for several hours. During her investigation, she noticed that the logs are full of millions of connection attempts from systems around the world, but those attempts were never completed. What type of attack likely took place?",
    "choice_a": "Cross-site scripting",
    "choice_b": "DDoS",
    "choice_c": "DoS",
    "choice_d": "Cross-site request forgery",
    "correct_answer": "B",
    "explanation": "This is a clear example of a distributed denial-of-service (DDoS) attack. The half-open connections indicate the use of a denial-of-service attack. The fact that the requests came from all over the world makes it clear that it is more than a standard denial-of-service attack. There is no indication that there was a web application flaw, such as cross-site request forgery or cross-site scripting.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      118,
      111,
      94,
      114,
      120
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 132,
    "question": "In the image shown here, what type of attack is Mal waging against Alice?<img src=\"/question_assets/DataSys+/c07uf002.png\"/>",
    "choice_a": "On-path attack",
    "choice_b": "Social engineering attack",
    "choice_c": "Brute-force attack",
    "choice_d": "SQL injection attack",
    "correct_answer": "A",
    "explanation": "In this figure, Mal is intercepting the traffic that Alice is sending to the database server and passing it along to the database. This is an example of an on-path attack.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      119,
      92,
      111,
      104,
      117
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 133,
    "question": "Fran received a call from her company\u2019s help-desk supervisor telling her that customers were receiving email messages informing them of a special promotion available for a limited time. Upon investigating these messages, Fran learned that they were sent by an attacker who somehow gained possession of her organization\u2019s customer list. What term best describes this attack?",
    "choice_a": "Spearphishing",
    "choice_b": "Phishing",
    "choice_c": "Whaling",
    "choice_d": "SQL injection",
    "correct_answer": "A",
    "explanation": "Answering this question correctly is a little confusing because there are two possible correct answers. This is a common occurrence on CompTIA exams. This is definitely a phishing attack, because it is soliciting sensitive information from customers over email. However, it is better described as a spearphishing attack because it was not sent blindly to many recipients but rather targeted at individuals who are actually customers of the company. It is not a whaling attack because it did not target a high-value individual. It is not an SQL injection attack because no attempt was made to access a database. When answering exam questions, keep an eye out for cases where two answers might be correct and then choose the one that is the BEST answer.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      121,
      98,
      95,
      94,
      82
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 134,
    "question": "Kim is the system administrator for a small business network that is experiencing security problems. She is in the office in the evening working on the problem, and nobody else is there. As she is watching, she can see that systems on the other side of the office that were previously behaving normally are now exhibiting signs of infection one after the other. What type of malware is Kim likely dealing with?",
    "choice_a": "Virus",
    "choice_b": "Worm",
    "choice_c": "Trojan horse",
    "choice_d": "Logic bomb",
    "correct_answer": "B",
    "explanation": "Worms have built-in propagation mechanisms that do not require user interaction, such as scanning for systems containing known vulnerabilities and then exploiting those vulnerabilities to gain access. Viruses and Trojan horses typically require user interaction to spread. Logic bombs do not spread from system to system but lie in wait until certain conditions are met, triggering the delivery of their payload.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      120,
      118,
      121,
      111,
      104
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 135,
    "question": "What technology is commonly used to logically group related systems on a network regardless of their physical location?",
    "choice_a": "Firewalls",
    "choice_b": "VLANs",
    "choice_c": "Port security",
    "choice_d": "Biometrics",
    "correct_answer": "B",
    "explanation": "Virtual LANs (VLANs) allow you to logically group together related systems, regardless of where they normally exist on the network. Firewalls are used to restrict the traffic that may enter and leave a network. Port security is used to limit the devices that may physically connect to a network. Biometrics are used to control access to systems and facilities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      112,
      111,
      113,
      114,
      83
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 136,
    "question": "Darcy would like to implement port security on her network. Which one of the following network devices can implement this control?",
    "choice_a": "Switch",
    "choice_b": "Router",
    "choice_c": "Firewall",
    "choice_d": "Bridge",
    "correct_answer": "A",
    "explanation": "Port security is a switch-based control that is used to limit the devices that may connect to a physical switch port based upon their MAC address.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      113,
      114,
      111,
      112,
      83
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 137,
    "question": "Ryan is installing antivirus software on his database server. The software is designed to watch for known signs of common malware. What technique is he using?",
    "choice_a": "Rapid detection",
    "choice_b": "Behavior detection",
    "choice_c": "Blind detection",
    "choice_d": "Signature detection",
    "correct_answer": "D",
    "explanation": "Signature detection uses databases of known malware patterns and scans the files and memory of a system for any data matching the pattern of known malicious software. Behavior detection takes a different approach. Instead of using patterns of known malicious activity, these systems attempt to model normal activity and then report when they discover anomalies\u2014activity that deviates from that normal pattern. Blind detection and rapid detection are not malware detection techniques.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      120,
      94,
      104,
      121,
      106
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 138,
    "question": "Carl is a help-desk technician and received a call from an executive who received a suspicious email message. The content of the email is shown here. What type of attack most likely took place?<img src=\"/question_assets/DataSys+/c07uf004.png\"/>",
    "choice_a": "Phishing",
    "choice_b": "Whaling",
    "choice_c": "Vishing",
    "choice_d": "Spearphishing",
    "correct_answer": "A",
    "explanation": "This is a straightforward phishing attack. The message is generic and not targeted at a specific user, as you would find in a spearphishing attack. Although the user is an executive, there is no indication that the message was specifically sent to this user because of his status as an executive, so it is not likely a whaling attack. The attack was sent over email, not the telephone, so it is not an example of vishing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      121,
      122,
      120,
      119,
      118
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 139,
    "question": "Dorian is investigating an attack has where the attacker large lists of usernames and passwords stolen during attacks against large websites. They then attempted to use those lists to log into systems belonging to Dorian\u2019s organization. What type of attack took place?",
    "choice_a": "Password-spraying",
    "choice_b": "Dictionary attack",
    "choice_c": "Brute-force attack",
    "choice_d": "Credential-stuffing",
    "correct_answer": "D",
    "explanation": "This is an example of a credential-stuffing attack where the attacker stole a set of usernames and passwords from a website and then used those same username/password combinations to attempt to log into other sites. Brute-force attacks simply try to guess a user\u2019s password by trying all possible combinations. Dictionary attacks refine brute-force attacks by using words found in a master dictionary to inform guesses. Password-spraying attacks are a form of brute-force attack that attempts to use a single password or a small set of passwords against many accounts.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      122,
      90,
      88,
      89,
      103
    ],
    "source": "180059_Ch07"
  },
  {
    "id": 140,
    "question": "James is working with his organization\u2019s leadership to help them understand the role that disaster recovery plays in their cybersecurity strategy. The leaders are confused about the differences between disaster recovery and business continuity. What is the end goal of disaster recovery planning?",
    "choice_a": "Preventing business interruption",
    "choice_b": "Setting up temporary business operations",
    "choice_c": "Restoring normal business activity",
    "choice_d": "Minimizing the impact of a disaster",
    "correct_answer": "C",
    "explanation": "Once a disaster interrupts the business operations, the goal of DRP is to restore regular business activity as quickly as possible. Thus, disaster recovery planning picks up where business continuity planning leaves off. Preventing business interruption is the goal of business continuity, not disaster recovery programs. While disaster recovery programs are involved in setting up temporary operations and minimizing the impact of disasters, this is not their end goal.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      143,
      132,
      133,
      135,
      142
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 141,
    "question": "Kevin is attempting to determine an appropriate backup frequency for his organization\u2019s database server and wants to ensure that any data loss is within the organization\u2019s risk appetite. Which one of the following security process metrics would best assist him with this task?",
    "choice_a": "RTO",
    "choice_b": "MTD",
    "choice_c": "RPO",
    "choice_d": "MTBF",
    "correct_answer": "C",
    "explanation": "The recovery point objective (RPO) specifies the maximum amount of data that may be lost during a disaster and should be used to guide backup strategies. The maximum tolerable downtime (MTD) and recovery time objective (RTO) are related to the duration of an outage, rather than the amount of data lost. The mean time between failures (MTBF) is related to the frequency of failure events.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      135,
      134,
      147,
      150,
      145
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 142,
    "question": "Brian\u2019s organization recently suffered a disaster and wants to improve their disaster recovery program based upon their experience. Which one of the following activities will best assist with this task?",
    "choice_a": "Training programs",
    "choice_b": "Awareness efforts",
    "choice_c": "Impact analysis review",
    "choice_d": "Lessons learned",
    "correct_answer": "D",
    "explanation": "The lessons learned session captures discoveries made during the disaster recovery process and facilitates continuous improvement. It may identify deficiencies in training and awareness or the impact analysis.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      142,
      141,
      132,
      143,
      136
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 143,
    "question": "Brad is helping to design a disaster recovery strategy for his organization and is analyzing possible storage locations for backup data. He is not certain where the organization will recover operations in the event of a disaster and would like to choose an option that allows them the flexibility to easily retrieve data from any DR site. Which one of the following storage locations provides the best option for Brad?",
    "choice_a": "Primary data center",
    "choice_b": "Field office",
    "choice_c": "Cloud computing",
    "choice_d": "IT manager's home",
    "correct_answer": "C",
    "explanation": "Cloud computing services provide an excellent location for backup storage because they are accessible from any location. The primary data center is a poor choice, as it may be damaged during a disaster. A field office is reasonable, but it is in a specific location and is not as flexible as a cloud-based approach. The IT manager\u2019s home is a poor choice, as the IT manager may leave the organization or may not have appropriate environmental and physical security controls in place.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      146,
      150,
      132,
      135,
      149
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 144,
    "question": "Randi is designing a disaster recovery mechanism for her organization\u2019s critical business databases. She selects a strategy where an exact, up-to-date copy of the database is maintained at an alternative location. What term describes this approach?",
    "choice_a": "Transaction logging",
    "choice_b": "Log shipping",
    "choice_c": "Database dumping",
    "choice_d": "Remote mirroring",
    "correct_answer": "D",
    "explanation": "When you use remote mirroring, an exact copy of the database is maintained at an alternative location. You keep the remote copy up-to-date by executing all transactions on both the primary and remote site at the same time. Database dumping follows a similar process of storing all data at the remote location, but it does not do so in real time. Transaction logging and log shipping send logs, rather than full data replicas, to the remote location.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      140,
      135,
      137,
      139,
      145
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 145,
    "question": "Ingrid is concerned that one of her organization\u2019s data centers has been experiencing a series of momentary power outages. Which one of the following controls would best preserve their operating status?",
    "choice_a": "Generator",
    "choice_b": "Dual power supplies",
    "choice_c": "UPS",
    "choice_d": "Redundant network links",
    "correct_answer": "C",
    "explanation": "An uninterruptible power supply (UPS) provides a battery-backed source of power that is capable of preserving operations in the event of brief power outages. Generators take a significant amount of time to start and are more suitable for longer-term outages. Dual power supplies protect against power supply failures and not power outages. Redundant network links are a network continuity control and do not provide power.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      128,
      137,
      139,
      135,
      132
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 146,
    "question": "Harry is conducting a disaster recovery test. He moved a group of personnel to the alternate recovery site where they are mimicking the operations of the primary site but do not have operational responsibility. What type of disaster recovery test is he performing?",
    "choice_a": "Checklist test",
    "choice_b": "Structured walk-through",
    "choice_c": "Simulation test",
    "choice_d": "Parallel test",
    "correct_answer": "D",
    "explanation": "The parallel test involves relocating personnel to the alternate recovery site and implementing site activation procedures. Checklist tests, structured walk-throughs, and simulations are all test types that do not involve actually activating the alternate site.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      141,
      132,
      133,
      135,
      136
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 147,
    "question": "Vince would like to perform a backup that will copy only those files that have been modified since the most recent full backup. What type of backup should he perform?",
    "choice_a": "Full backup",
    "choice_b": "Incremental backup",
    "choice_c": "Transaction log backup",
    "choice_d": "Differential backup",
    "correct_answer": "D",
    "explanation": "Differential backups copy all files modified since the most recent full backup. Incremental backups copy all files that have been modified since the most recent full or incremental backup. Full backups copy all files. Transaction log backups copy database transactions, rather than files.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      145,
      150,
      147,
      148,
      140
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 148,
    "question": "What combination of backup strategies provides the fastest backup restoration time?",
    "choice_a": "Full backups and differential backups",
    "choice_b": "Partial backups and incremental backups",
    "choice_c": "Full backups and incremental backups",
    "choice_d": "Incremental backups and differential backups",
    "correct_answer": "A",
    "explanation": "Any backup strategy must include full backups at some point in the process. If a combination of full and differential backups is used, a maximum of two backups must be restored. If a combination of full and incremental backups is chosen, the number of required restorations may be large.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      145,
      150,
      135,
      148,
      147
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 149,
    "question": "What type of disaster recovery plan test fully evaluates operations at the backup facility but does not shift primary operations responsibility from the main site?",
    "choice_a": "Structured walk-through",
    "choice_b": "Parallel test",
    "choice_c": "Full-interruption test",
    "choice_d": "Simulation test",
    "correct_answer": "B",
    "explanation": "Parallel tests involve moving personnel to the recovery site and gearing up operations, but responsibility for conducting day-to-day operations of the business remains at the primary operations center.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      141,
      132,
      135,
      134,
      136
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 150,
    "question": "Gavin is conducting a test of his organization\u2019s disaster recovery plan and reached the phase of the test where they shut down the primary data center. What type of test is he running?",
    "choice_a": "Parallel test",
    "choice_b": "Simulation",
    "choice_c": "Walk-through",
    "choice_d": "Full interruption",
    "correct_answer": "D",
    "explanation": "Full-interruption tests are the only type of test where the primary data center is shut down. Parallel tests also activate the alternate processing facility but do not shift operational responsibility away from the primary data center. Simulations and walk-throughs do not activate the alternate site.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      141,
      132,
      135,
      134,
      136
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 151,
    "question": "What database backup technology applies database transactions in real time at both primary and alternate sites?",
    "choice_a": "Remote mirroring",
    "choice_b": "Database dumping",
    "choice_c": "Log shipping",
    "choice_d": "Fault tolerance",
    "correct_answer": "A",
    "explanation": "Remote mirroring technology maintains mirrored images of servers at both the primary and alternate sites. Database dumping copies full data to a backup site but does not do so in real time. Log shipping copies only transaction log entries to the remote site. Fault tolerance is a mechanism to increase the resilience of technology systems against failures.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      140,
      137,
      135,
      139,
      138
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 152,
    "question": "Barbara configures a system to perform full backups on Sundays and differential backups on Mondays through Saturdays. The system fails on Thursday. What backups must be applied?",
    "choice_a": "Sunday only",
    "choice_b": "Sunday, Monday, Tuesday, and Wednesday",
    "choice_c": "Sunday and Wednesday only",
    "choice_d": "Sunday, Monday, and Wednesday only",
    "correct_answer": "C",
    "explanation": "With differential backups, Barbara must first restore the most recent full backup and then apply the most recent differential backup.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      145,
      150,
      135,
      147,
      148
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 153,
    "question": "David gathered his organization\u2019s disaster recovery team on a videoconference and asked them to consider how they would respond if the area suffered an earthquake and they were unable to return to their primary facility. What type of testing is he conducting?",
    "choice_a": "Full-interruption test",
    "choice_b": "Parallel test",
    "choice_c": "Simulation test",
    "choice_d": "Structured walk-through",
    "correct_answer": "C",
    "explanation": "Simulation tests are similar to structured walk-throughs. In simulation tests, disaster recovery team members are presented with a scenario and asked to develop an appropriate response. That is the case in David\u2019s earthquake exercise. There is no activation of any alternate facility, as would take place in a full-interruption or parallel test.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      141,
      132,
      133,
      135,
      136
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 154,
    "question": "Kayleigh\u2019s organization recently suffered a disaster that disrupted their transactional database systems. She is working to stand up a temporary cloud database to support business activity. At what point is the DR effort complete?",
    "choice_a": "When the original database is back up and running again",
    "choice_b": "When the temporary database is built",
    "choice_c": "When data is restored to the temporary database",
    "choice_d": "When the temporary database is supporting business operations",
    "correct_answer": "A",
    "explanation": "The end goal of a disaster recovery effort is to transition back to normal operations. Kayleigh\u2019s work is not complete when the temporary database is up and running. The effort continues until the organization returns to a permanent state.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      132,
      135,
      140,
      142,
      143
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 155,
    "question": "Ricky is conducting the quantitative portion of his organization\u2019s business impact analysis. Which one of the following concerns is <i>least</i> suitable for quantitative measurement during this assessment?",
    "choice_a": "Loss of a plant",
    "choice_b": "Damage to a vehicle",
    "choice_c": "Negative publicity",
    "choice_d": "Power outage",
    "correct_answer": "C",
    "explanation": "It is difficult to put a dollar figure on the business lost because of negative publicity. Therefore, this type of concern is better evaluated through a qualitative analysis. The other items listed here are all more easily quantifiable.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      134,
      143,
      133,
      135,
      142
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 156,
    "question": "Adam is reviewing the fault tolerance controls used by his organization and realizes that they currently have a single point of failure in the disks used to support a critical server. Which one of the following controls can provide fault tolerance for these disks?",
    "choice_a": "Load balancing",
    "choice_b": "RAID",
    "choice_c": "Clustering",
    "choice_d": "HA pairs",
    "correct_answer": "B",
    "explanation": "Redundant arrays of inexpensive disks (RAID) are a fault tolerance control that allow an organization\u2019s storage service to withstand the loss of one or more individual disks. Load balancing, clustering, and HA pairs are all fault-tolerance services designed for server compute capacity, not storage.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      138,
      137,
      139,
      129,
      150
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 157,
    "question": "Bryn runs a corporate website and currently uses a single server, which is capable of handling the site\u2019s entire load. She is concerned, however, that an outage on that server could cause the organization to exceed its RTO. What action could she take that would best protect against this risk?",
    "choice_a": "Install dual power supplies in the server",
    "choice_b": "Replace the server\u2019s hard drives with RAID arrays",
    "choice_c": "Deploy multiple servers behind a load balancer",
    "choice_d": "Perform regular backups of the server",
    "correct_answer": "C",
    "explanation": "All of these are good practices that could help improve the quality of service that Bryn provides from her website. Installing dual power supplies or deploying RAID arrays could reduce the likelihood of a server failure, but these measures only protect against a single risk each. Deploying multiple servers behind a load balancer is the best option because it protects against any type of risk that would cause a server failure. Backups are an important control for recovering operations after a disaster and different backup strategies could indeed alter the RTO, but it is even better if Bryn can design a web architecture that lowers the risk of the outage occurring in the first place.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      137,
      139,
      135,
      129,
      132
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 158,
    "question": "Which one of the following plans would normally contain details on an organization\u2019s backup procedures?",
    "choice_a": "Systems security plan",
    "choice_b": "Continuity of operations plan",
    "choice_c": "Build documentation",
    "choice_d": "Disaster recovery plan",
    "correct_answer": "D",
    "explanation": "Disaster recovery plans tend to be tactical and describe technical activities such as recovery sites, backups, and fault tolerance. Business continuity activities are typically more strategically focused and center themselves on business processes and operations. The systems security plan focuses on the security controls that should be put in place during a disaster, and build documentation contains details on how to build new systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      132,
      143,
      145,
      150,
      137
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 159,
    "question": "What technology may be used to perform disk-to-disk backups with systems designed to work only with tapes?",
    "choice_a": "Journaling",
    "choice_b": "D2D",
    "choice_c": "VLAN",
    "choice_d": "VTL",
    "correct_answer": "D",
    "explanation": "Virtual tape libraries (VTL) are used to make disk-based storage appear as tape libraries to backup software expecting tapes. This is used to support disk-to-disk (D2D) backups, but D2D technology alone does not provide this functionality. Journaling is a backup technique used to write changes to a transaction log that is backed up. Virtual Local Area Networks (VLANs) are used to perform network segmentation and are not a backup technology.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      149,
      145,
      147,
      148,
      150
    ],
    "source": "180059_Ch08"
  },
  {
    "id": 160,
    "question": "You are in charge of making sure backups function correctly by randomly testing them. Which of the following methods would be your best choice to verify that your backups are properly maintained?",
    "choice_a": "Validate the backup hash values",
    "choice_b": "Review backup completion reports",
    "choice_c": "Move the backups off-site",
    "choice_d": "Duplicate the backups",
    "correct_answer": "A",
    "explanation": "Validating the backup hash is the best choice to verify that backups are properly maintained, as it allows you to compare the hash value of the original data with that of the backed-up data. If the hash values match, it is likely that the backup is complete and accurate. Reviewing a report of a successful backup only confirms that the backup process was completed, not necessarily the integrity of the data. Moving the backup off-site is a good practice for disaster recovery but does not provide any verification of the backup quality. Duplicating the backup creates additional copies, which can be helpful for redundancy but does not directly test the quality or functionality of the original backup.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      148,
      145,
      147,
      141,
      150
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 161,
    "question": "Which one of the following circumstances is the least likely to be identified by a continuous account monitoring system?",
    "choice_a": "A user logging in from an unusual location",
    "choice_b": "A user accessing data that is unrelated to a user\u2019s job",
    "choice_c": "A user accessing a database record that they do not have a business need to know",
    "choice_d": "A user downloading large quantities of sensitive information",
    "correct_answer": "C",
    "explanation": "Continuous account monitoring systems are designed to watch for suspicious activity and alert administrators to strange actions. They would normally catch situations where a user logs in from an unexpected location, accesses data unrelated to their job, or downloads large quantities of information because those actions are all easily recognizable as unusual. A user accessing a single record they do not need for their job is less likely to trigger an alert because it might resemble the user\u2019s normal behavior.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      70,
      52,
      58,
      57,
      61
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 162,
    "question": "Anila is a database administrator at a midsize company. She recently took over this role from a previous administrator who suddenly left. The company\u2019s database system has been experiencing performance issues, and Anila suspects the problem might be due to index fragmentation. However, no standard operating procedures (SOPs) are available to guide her. Which subject area of SOPs should Anila develop to best help her colleagues as she resolves the issue?",
    "choice_a": "System Architecture",
    "choice_b": "Data Quality",
    "choice_c": "Maintenance and Performance Tuning",
    "choice_d": "Change Management",
    "correct_answer": "C",
    "explanation": "The Maintenance and Performance Tuning subject area contains procedures for regularly scheduled tasks such as index maintenance and query optimization, which are directly related to the database\u2019s performance issue that Janet suspects. System Architecture mainly deals with the infrastructure components of the database system rather than the performance issues; Data Quality focuses on things like validating data feeds, handling duplicate data, and other steps to ensure the quality of data within the database rather than the performance; and Change Management is not the correct choice either as it primarily covers procedures related to making changes to the database schema.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      73,
      64,
      63,
      69,
      55
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 163,
    "question": "Omar is a network administrator at an automobile parts manufacturer. He is updating the configuration for the firewall that protects his Oracle database to allow access from a new Tableau reporting server using the default database port. What port does he need to ensure is open between the two servers?",
    "choice_a": "1433",
    "choice_b": "443",
    "choice_c": "5432",
    "choice_d": "1521",
    "correct_answer": "D",
    "explanation": "The default port for Microsoft SQL Server is 1433, the default for PostgreSQL is 5432, and 443 is the standard port for encrypted web traffic. 1521 is the default port for Oracle.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      111,
      114,
      92,
      96,
      104
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 164,
    "question": "Emily is a network administrator at a medium-sized company. She is tasked with deploying a new database server that will store sensitive company data. In which of the following network zones should she place the database server to ensure optimal security?",
    "choice_a": "Screened subnet",
    "choice_b": "Internet-facing",
    "choice_c": "Intranet",
    "choice_d": "Guest network",
    "correct_answer": "C",
    "explanation": "Placing the database server within the company\u2019s intranet ensures that it is protected by the border firewall and is not directly exposed to external threats, providing optimal security for sensitive data. The screened subnet, also known as the demilitarized zone (DMZ), is typically used for systems that accept connections from the outside world and has a higher risk of compromise, making it unsuitable for a sensitive database server. An Internet-facing location would expose the server directly to the Internet, making it vulnerable to attacks. Lastly, a guest network is designed for temporary and untrusted users, posing a significant security risk and making it an inappropriate location for a sensitive database server.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      111,
      112,
      85,
      107,
      92
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 165,
    "question": "Todd is a systems administrator in charge of recovering corporate web servers after a severe DDoS attack took down the systems. He would like to get the systems up and working before business functions become over-strained. Which of the following DR planning measurements is most applicable to Todd\u2019s situation?",
    "choice_a": "RTO",
    "choice_b": "MTD",
    "choice_c": "RPO",
    "choice_d": "MTTR",
    "correct_answer": "B",
    "explanation": "The correct answer is maximum tolerable downtime (MTD), which is the maximum amount of time a business function can tolerate a disruption before the harm becomes unrepairable. Recovery time objective (RTO) is the amount of time it is estimated to take for a business function to recover in a disruption. Recovery point objective (RPO) refers to the time before an incident where the organization should be able to recover data from a critical business process. Mean time to recovery or mean time to restore (MTTR) is the average time to reach system restoration.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      134,
      135,
      132,
      133,
      141
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 166,
    "question": "Samantha is a database administrator at a large corporation and has been tasked with implementing an off-site backup solution for their critical databases. She needs to minimize data loss and recovery time in the event of a disaster. Which backup solution should she choose?",
    "choice_a": "Database dumping",
    "choice_b": "Log shipping",
    "choice_c": "Local mirroring",
    "choice_d": "Remote mirroring",
    "correct_answer": "D",
    "explanation": "Remote mirroring is the optimal choice for minimizing data loss and recovery time, as it maintains a live database server at the backup site with real-time current data, ensuring minimal data loss and swift recovery. Database dumping, on the other hand, can result in significant data loss due to gaps between dump operations and requires more time to restore the database. Log shipping, while transferring data more frequently than database dumping, is still not real-time and necessitates some restoration time. Lastly, local mirroring is not an off-site backup solution, and thus it doesn\u2019t offer protection against disasters affecting the primary site.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      140,
      135,
      137,
      146,
      150
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 167,
    "question": "Herman, a database administrator at a logistics company, is working on a project to integrate real-time data from handheld scanners drivers use during package delivery. To ensure the new database can interact with this data source in real time, which of the following aspects should be included in the database design process?",
    "choice_a": "Selecting Windows Server as the operating system for the database server",
    "choice_b": "Implementing an API platform",
    "choice_c": "Creating a data dictionary for the database",
    "choice_d": "Resolving any many-to-many relationships in the ERD",
    "correct_answer": "B",
    "explanation": "While a database server needs an operating system, the OS does not directly impact how the database interacts with real-time data sources like handheld scanners.<br>A data dictionary is a useful resource for understanding the structure and relationships of database objects.<br>Resolving many-to-many relationships in the ERD is essential when implementing a database.<br>Implementing an API platform is the correct answer because an API layer adds consistency to database queries, stabilizes performance, and simplifies operations when dealing with real-time data sources, such as handheld scanners.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      40,
      46,
      48,
      49,
      45
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 168,
    "question": "Blake needs to send linear employee data to his company\u2019s health insurance provider. What should Blake do?",
    "choice_a": "Create a database user and give the health insurance provider access to the production database.",
    "choice_b": "Create a CSV file containing the required data and transmit it securely to the health insurance provider.",
    "choice_c": "Create a database user and give the health insurance provider access to a read replica of the production database.",
    "choice_d": "Create a nested JSON file containing the required data and transmit it securely to the health insurance provider.",
    "correct_answer": "B",
    "explanation": "Giving an external entity access direct database access is not a best practice. Since this data is linear, JSON is not necessary, so a CSV file is the best approach.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      85,
      83,
      84,
      92,
      99
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 169,
    "question": "Samantha is a data systems analyst at a retail company. After a week of unexpectedly high sales volumes, she noticed a degradation in database query performance. Looking at the execution plans of some top queries, she sees they no longer use indexes that cover the queries. Which of the following options might address her situation?",
    "choice_a": "Create a new index",
    "choice_b": "Create a new view",
    "choice_c": "Rebuild the existing indexes",
    "choice_d": "Rebuild an existing view",
    "correct_answer": "C",
    "explanation": "Rebuilding the existing indexes should update the statistics the optimizer uses to determine query execution plans and is Samantha\u2019s best option. Creating a new index isn\u2019t necessary, as queries performed well in the past. Creating or rebuilding a view doesn\u2019t apply in this situation.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      64,
      63,
      57,
      55,
      54
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 170,
    "question": "Rochdi is a database administrator for a large organization responsible for maintaining the quality and integrity of the company\u2019s databases. He is currently reviewing the schema and data types of a particular database. What type of quality check is Rochdi primarily performing to ensure the correctness and consistency of the database?",
    "choice_a": "Code quality checks",
    "choice_b": "Schema validation",
    "choice_c": "Version control checks",
    "choice_d": "Nullability checks",
    "correct_answer": "B",
    "explanation": "Code quality checks focus on the correctness, efficiency, and maintainability of the database code; version control checks validate the use of version control software in the environment; and nullability checks ensure that optional columns are nullable and required columns are not. Schema validation validates that the database implementation conforms to the original requirements, including schema design and data types.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      43,
      48,
      51,
      50,
      45
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 171,
    "question": "Monique is a database developer working with customer information and notices that one of her queries retrieves data from the Customer table. However, the query is not performing as quickly as expected under load. What should Monique focus on to improve the query performance, as she suspects the query is not covered?",
    "choice_a": "Index analysis",
    "choice_b": "Data mapping",
    "choice_c": "Data values",
    "choice_d": "Query validation",
    "correct_answer": "A",
    "explanation": "Data mapping ensures that data elements consistently map to similar data types as data flows between the database and the systems it interacts with. Focusing on data values ensures the accuracy, consistency, and completeness of data stored in the database. While query validation involves testing the correctness and performance of SQL queries, index analysis is a better answer as it focuses on analyzing and optimizing database indexes to improve query performance.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      63,
      64,
      57,
      69,
      55
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 172,
    "question": "Maria is a database administrator for a midsize company. The company\u2019s application enforces a business rule that forces users to change their passwords monthly and prevents users from using any of their three most recently used passwords. Maria needs to validate that no user is violating this password reuse rule. Which integrity check is Maria using to validate this business rule?",
    "choice_a": "Referential integrity",
    "choice_b": "User-defined integrity",
    "choice_c": "Domain integrity",
    "choice_d": "Entity integrity",
    "correct_answer": "B",
    "explanation": "User-defined integrity checks validate business rules not natively enforced by the database. In Maria\u2019s case, validating the business rule governing password reuse requires a custom integrity check under user-defined integrity. Referential integrity validates relationships between tables, domain integrity ensures column values adhere to business rules and column definitions but does not enforce custom business rules like password reuse, and entity integrity ensures that tables have primary keys, which doesn\u2019t directly validate any business rules and therefore is not the appropriate choice in this case.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      48,
      41,
      43,
      37
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 173,
    "question": "Amy is a data systems analyst at Global Logistics, a company with an extensive customer database. Leadership wants to improve customer relations by keeping track of their default shipping speed preferences. What should Amy do to accommodate this new initiative? Choose the best answer.",
    "choice_a": "For each customer, find the most recently used shipping speed and make that the default",
    "choice_b": "Create an index on the column for customer shipping options",
    "choice_c": "Create a new table to store the default preference",
    "choice_d": "Append a column to the customer table to store this default preference",
    "correct_answer": "D",
    "explanation": "Since this is a new attribute about existing customers, Amy should append a column to the customer table to store this default preference. Using the most recently used shipping speed may differ from what each customer wants as a default, and nothing in this answer accommodates storing this new information. Similarly, creating an index for customer shipping options doesn\u2019t accommodate storing new data. While creating a new table is possible, augmenting an existing table is simple and eliminates a join to retrieve this information.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      43,
      37,
      40,
      36,
      51
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 174,
    "question": "Dahlia is developing a data warehouse and wants to analyze stock market trends. Which database engine is optimal for Dahlia\u2019s needs?",
    "choice_a": "Relational",
    "choice_b": "Key-value",
    "choice_c": "Column-oriented",
    "choice_d": "Graph",
    "correct_answer": "C",
    "explanation": "A column-oriented database excels at analyzing/aggregating specific columns of data. Graphs are ideal for connected data problems. A relational database is ideal for tabular data. A key-value store is a good technique for searching based on a known key.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      2,
      14,
      27,
      31
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 175,
    "question": "Mohammed is a data analyst designing a new database schema for the e-commerce platform at his company. He needs to develop a high-level representation of the organization\u2019s data that defines the relationships between entities without including implementation details such as data types or database structures. Which of the following modeling techniques should Mohammed begin with?",
    "choice_a": "Logical schema design",
    "choice_b": "Conceptual data modeling",
    "choice_c": "Physical schema design",
    "choice_d": "Database view design",
    "correct_answer": "B",
    "explanation": "Logical schema design builds on the conceptual model.<br>Physical schema design involves creating a detailed, low-level representation of the database structure that includes all the technical details necessary for the physical implementation of the database.<br>Database view design deals with the design of database views.<br>Conceptual data modeling is correct because it focuses on creating a high-level representation of an organization\u2019s data without including implementation details such as data types or database structures.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      43,
      37,
      36,
      40,
      41
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 176,
    "question": "Ella is trying to select an object-relational mapping tool for her team of Python developers. Which is her best option?",
    "choice_a": "ActiveRecord",
    "choice_b": "Ebean",
    "choice_c": "Hibernate",
    "choice_d": "Storm",
    "correct_answer": "D",
    "explanation": "While all of these are ORM frameworks, Ebean and Hibernate both support Java, and ActiveRecord is for Ruby on Rails. Storm is among the options for Python.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      18,
      16,
      17,
      35,
      4
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 177,
    "question": "Pedro, a database administrator at a large organization, is planning to design a new database. To ensure that the database meets the needs of its users and applications, he wants to consult with stakeholders responsible for writing applications that interact with the database using generalized programming languages. Which of the following stakeholders should Pedro consult for this purpose?",
    "choice_a": "Application developers",
    "choice_b": "Data analysts",
    "choice_c": "Database developers",
    "choice_d": "System administrators",
    "correct_answer": "A",
    "explanation": "Data analysts use the database to perform complex queries, generate reports, and perform other data-related tasks. While they play a vital role in working with the database, they do not write applications that interact with it using generalized programming languages.<br>Database developers write SQL to create tables, views, stored procedures, and other database objects. They may occasionally be involved in maintaining or upgrading the database. However, they do not focus on writing applications that interact with the database using generalized programming languages.<br>System administrators operate the virtual or physical servers where the database runs, handling tasks such as server sizing, disk-space allocation, and operating system upgrades and maintenance. While they are crucial for the database infrastructure, they do not write applications that interact with the database using generalized programming languages.<br>Application developers is the correct answer. Application developers write applications that interact with the database using generalized programming languages like JavaScript, Java, and C#. They create APIs, mobile applications, or web applications that store data in the database. Consulting with them will help Pedro ensure that the database design meets the needs of applications that interact with it.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      36,
      37,
      40,
      44,
      48
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 178,
    "question": "Swan is a junior data systems analyst at a fitness club franchise that wants to start offering tai chi classes. Currently, there is an Exercise_Type reference table that has a list of current exercise classes. What does Swan need to do to allow fitness club members to register for tai chi?",
    "choice_a": "Create a view that incorporates tai chi",
    "choice_b": "Create an index on the primary key of the Exercise_Type table",
    "choice_c": "Add a new column to the Exercise_Type table for tai chi",
    "choice_d": "Modify the Exercise_Type table to add a row for tai chi",
    "correct_answer": "D",
    "explanation": "Swan needs to modify the data in the Exercise_Type table by adding a row for tai chi. Neither creating a view nor creating an index on the primary key would help, as the data for tai chi doesn\u2019t exist in the database. Creating a new column for tai chi is incorrect as tai chi isn\u2019t an attribute of the exercises currently offered by the fitness club.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      21,
      3,
      19,
      20,
      26
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 179,
    "question": "Jim is a database administrator looking into choosing a replication method for his database. He would like to reduce recovery time in the event of an emergency to meet his RTO and SLA. Which of the following methods would best serve Jim\u2019s needs?",
    "choice_a": "Log shipping",
    "choice_b": "Database dumping",
    "choice_c": "Differential backups",
    "choice_d": "Remote mirroring",
    "correct_answer": "D",
    "explanation": "Remote mirroring best serves Jim\u2019s needs as it offers near real-time replication of data, ensuring minimal recovery time and meeting RTO and SLA requirements. In comparison, log shipping involves periodically transferring logs, leading to longer recovery times, while database dumping requires restoring the entire database, which can be time-consuming. Differential backups are a backup strategy rather than a data replication method.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      140,
      135,
      137,
      139,
      134
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 180,
    "question": "Rita, a lead data systems analyst at a large retailer, has been asked to create a fail-safe procedure for the company\u2019s database system. This procedure should ensure minimal data loss during unexpected hardware failures or system crashes. Which standard operating procedures (SOPs) section is Rita working on?",
    "choice_a": "System Architecture",
    "choice_b": "Vendor Management",
    "choice_c": "Data Backup and Restoration",
    "choice_d": "Troubleshooting",
    "correct_answer": "C",
    "explanation": "The Data Backup and Restoration section provides detailed instructions on when and how to perform data backups, where backups are stored, and the steps for restoring data. These procedures are critical to ensure minimal data loss and swift recovery during hardware failures or system crashes. System Architecture is incorrect because it focuses on describing the database, its infrastructure components, and what connects to it. Vendor Management describes how third parties interact with the organization, and Troubleshooting describes how to analyze unexpected database behavior.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      145,
      147,
      148,
      150,
      140
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 181,
    "question": "Ibrahim is not sure that the code generated by Hibernate is as efficient as the SQL he wrote on his own. What should he do next?",
    "choice_a": "Switch ORM frameworks from Hibernate to Ebean",
    "choice_b": "Compare the explain plans of the Hibernate-generated SQL and his handwritten SQL",
    "choice_c": "Regenerate the database code within Hibernate",
    "choice_d": "Replace the Hibernate-generated SQL with his handwritten SQL",
    "correct_answer": "B",
    "explanation": "Before making a decision, Ibrahim needs to validate there is a performance difference, so replacing the Hibernate code with his code is not the best option. Switching frameworks or regenerating the database code would not allow him to compare any perceived difference in efficiency.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      63,
      55,
      54,
      57,
      66
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 182,
    "question": "Molly is a project manager tasked with developing a new database system for her organization. She understands that gathering requirements for the database design is essential and is working to identify stakeholders. Which of the following stakeholders would use data from the database to track organizational performance metrics and inform strategic decisions?",
    "choice_a": "End users",
    "choice_b": "Data analysts",
    "choice_c": "Database administrators",
    "choice_d": "Executive management",
    "correct_answer": "D",
    "explanation": "End users directly input or retrieve data from the database but are not typically responsible for tracking organizational performance metrics or making strategic decisions based on database data.<br>Data analysts use the database to perform complex queries, generate reports, and perform other data-related tasks. They defer to executive management regarding strategic direction.<br>Database administrators (DBAs) are responsible for the ongoing maintenance and management of the database. Their tasks include backups, performance tuning, security, and database upgrades. They do not primarily use the database data to track organizational performance metrics and make strategic decisions.<br>Executives use data from the database to track organizational performance metrics and inform strategic decisions. They most frequently use reporting tools like Tableau, Qlik, or Power BI, instead of interacting directly with the database.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      36,
      40,
      37,
      44,
      41
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 183,
    "question": "Jen, a junior data systems analyst at a motorcycle manufacturer, is updating the ERD of her existing Oracle database. Which of the following tools will she most likely use to extend the existing design and generate the associated DDL?",
    "choice_a": "SQL Developer Data Modeler",
    "choice_b": "MySQL Workbench",
    "choice_c": "Google Drawings",
    "choice_d": "Visual Paradigm",
    "correct_answer": "A",
    "explanation": "Jen, a junior data systems analyst at a motorcycle manufacturer, is updating the ERD of her existing Oracle database. Which of the following tools will she most likely use to extend the existing design and generate the associated DDL? Choose the best answer.<br>While all listed options support creating ERDs, Oracle\u2019s product in the data modeling space is SQL Developer Data Modeler. MySQL Workbench primarily supports MySQL, while Google Drawings and Visual Paradigm are more generic data modeling tools.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      43,
      45,
      44,
      37,
      36
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 184,
    "question": "Leo, a data systems analyst at a small startup, is designing a database to support operations. As part of the design, Leo needs to create an ERD depicting each table, its structure, and how it relates to other tables. Which of the following tools is best suited to Leo\u2019s needs?",
    "choice_a": "Excel",
    "choice_b": "Visio",
    "choice_c": "Word",
    "choice_d": "Sheets",
    "correct_answer": "B",
    "explanation": "Visio is a diagramming tool Leo can use to create ERDs. Excel and Sheets are both spreadsheets, and Word is a word processor.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      72,
      71,
      75,
      76,
      61
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 185,
    "question": "Farid is developing a recommendation engine to suggest products based on a customer\u2019s purchase history. Which database engine is optimal for Farid\u2019s needs?",
    "choice_a": "Relational",
    "choice_b": "Key-value",
    "choice_c": "Column-oriented",
    "choice_d": "Graph",
    "correct_answer": "D",
    "explanation": "As recommendations are based on connected data, a graph database is the optimal choice. A relational database is ideal for tabular data. A key-value store is a good searching tool based on a known key. A column-oriented database excels at analyzing/aggregating specific columns of data.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      13,
      10,
      2,
      14,
      12
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 186,
    "question": "Abe, a system administrator at a company using Microsoft Windows, needs to automate various administrative tasks on their servers. He wants a modern, powerful, and flexible Windows-centric scripting language to manage processes, services, and file systems efficiently. Which scripting language should Abe choose?",
    "choice_a": "Bash",
    "choice_b": "VBScript",
    "choice_c": "Python",
    "choice_d": "PowerShell",
    "correct_answer": "D",
    "explanation": "PowerShell is a powerful and flexible scripting language specifically designed for the Windows environment. It provides a feature-rich, advanced environment for automating tasks in Windows and has numerous modules available for managing processes, services, and file systems, and is an ideal choice for Abe. Bash is most common on Linux, and while VBScript is Windows-centric, it predates PowerShell. Although Python is a reasonable choice, it is not specifically designed for Windows.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      4,
      35,
      33,
      6
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 187,
    "question": "Lily is looking at the following two tables. Multiple subcomponents can make a product. What should Lily do to improve data quality and consistency?<img src=\"/question_assets/DataSys+/ptq028.png\"/>",
    "choice_a": "Implement a foreign key in the Subcomponent table that references the Product_ID in the Product table.",
    "choice_b": "Lily doesn\u2019t have to do anything; the design enforces data quality as is.",
    "choice_c": "Drop the Subcomponent table.",
    "choice_d": "Implement a foreign key in the Product table that references the Subcomponent_ID in the Subcomponent table.",
    "correct_answer": "A",
    "explanation": "Since there is no relationship between the two tables, they are not related. Lily needs to implement a foreign key. Since multiple subcomponents can exist for a product, the foreign key has to be on the Subcomponents table, pointing to the primary key of the Product table. Dropping the Subcomponent table is incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      43,
      51,
      48,
      37,
      40
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 188,
    "question": "Tamia is a database administrator for a large e-commerce company active in four unique regions. She\u2019s been observing slow query performance on the Regions table, which has four rows, one for each region. Which index type is the most appropriate for Tamia to improve query performance?",
    "choice_a": "B-tree index",
    "choice_b": "Nonclustered index",
    "choice_c": "Bitmap index",
    "choice_d": "Hash index",
    "correct_answer": "C",
    "explanation": "A bitmap index is efficient for columns with limited unique values, like the Regions table. While hash, nonclustered, and b-tree indexes are all viable options, the limited number of unique values in the columns make bitmap an ideal choice.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      6,
      33,
      9,
      14,
      5
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 189,
    "question": "Geronimo is a database administrator building a robust backup process. He is afraid that in between backups, his server might experience a crash and data might be lost. Which of the following technologies could Geronimo utilize to reduce this risk?",
    "choice_a": "HSM",
    "choice_b": "NIC teaming",
    "choice_c": "Load balancing",
    "choice_d": "RAID",
    "correct_answer": "D",
    "explanation": "To reduce the risk of data loss between backups, Geronimo could utilize redundant array of independent disks (RAID) technology. RAID provides data redundancy by storing data across multiple disks, which can help prevent data loss in the event of a single disk failure. In contrast, hardware security modules (HSM) focus on managing encryption keys, not on preventing data loss. Load balancing and network interface card (NIC) teaming are both related to distributing network traffic, improving performance, and providing fault tolerance, but they do not directly address the issue of data loss in between backups.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      138,
      137,
      135,
      140,
      150
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 190,
    "question": "As a data systems analyst at an insurance company, Amita manages the inbound batch files that get bulk loaded into her company\u2019s database. Because of a recent network irregularity, Amita is concerned with the data integrity of the files. While Amita thinks that each file usually contains 100 records, she isn\u2019t sure. What can she do before loading them into the database to ensure the files have the data as transmitted?",
    "choice_a": "Perform a range check on the first column in the file",
    "choice_b": "Verify that each file contains 100 records",
    "choice_c": "Disable transaction logging",
    "choice_d": "Verify the checksum of each file",
    "correct_answer": "D",
    "explanation": "Comparing the checksum of the files to the checksum of the transmitted files will help Amita verify whether the files are corrupt. Performing a range check to see if data falls within a specified range does not apply to this scenario. Checking for 100 records is arbitrary, as Amita does not know how many records each file should contain. Disabling transaction logging may speed bulk load operations but have nothing to do with verifying file integrity before the load.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      96,
      106,
      104,
      101,
      92
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 191,
    "question": "Carlos is a database developer working on a banking application. He needs to create a precompiled set of SQL statements that can be called from multiple parts of the application to withdraw funds from a customer\u2019s account while ensuring the account has sufficient funds and maintaining an audit trail. Which database object should he use for this purpose?",
    "choice_a": "Trigger",
    "choice_b": "Function",
    "choice_c": "Stored procedure",
    "choice_d": "View",
    "correct_answer": "C",
    "explanation": "Triggers are database objects that execute SQL automatically when an event occurs, such as inserting, updating, or deleting data in a table. While functions are precompiled sets of SQL statements, they typically return a single value and are too granular for what Carlos is trying to accomplish. A view presents the result set of a SELECT statement as a virtual table. Although views can be used to suppress sensitive information or simplify complex queries, they are not suitable for implementing callable business logic, like the withdrawal process Carlos needs to create. Stored procedures contain precompiled sets of SQL statements stored within the database. Carlos can create a stored procedure that validates input parameters, checks the account\u2019s balance, and updates the account table while making a transaction history record.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      24,
      34,
      23,
      26,
      21
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 192,
    "question": "Mia\u2019s disaster recovery team has recently eradicated a worm that had propagated through the corporate network. She and her team are gathered for a lessons-learned session following the conclusion of this disruption. Who would be the ideal individual to lead the session?",
    "choice_a": "Chief information security officer",
    "choice_b": "IT manager",
    "choice_c": "Chief information officer",
    "choice_d": "Independent facilitator",
    "correct_answer": "D",
    "explanation": "An independent facilitator would be the ideal individual to lead the lessons learned session following the worm incident. This person can provide an unbiased perspective, facilitating open and honest discussions about the event and ensuring that all relevant issues are addressed. While the chief information security officer, IT manager, and chief information officer may all have valuable insights, their involvement in the organization might lead to biases or defensive stances, potentially hindering a comprehensive analysis of the situation. An independent facilitator can foster a more productive conversation and help the team extract valuable lessons from the experience.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      142,
      141,
      132,
      143,
      144
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 193,
    "question": "Gemma is a database administrator working on a financial application that transfers money between accounts. She needs to use a suitable Transaction Control Language (TCL) command to ensure data consistency and reliability during the transfer process. Which command should Jennifer use when combining multiple related SQL statements into a single logical group?",
    "choice_a": "BEGIN TRANSACTION",
    "choice_b": "ROLLBACK",
    "choice_c": "COMMIT",
    "choice_d": "SAVEPOINT",
    "correct_answer": "A",
    "explanation": "COMMIT saves the changes made by a SQL statement, ROLLBACK reverts changes, and SAVEPOINT establishes a marker within an ongoing transaction, allowing for a partial rollback to this marker instead of rolling back the entire transaction. BEGIN TRANSACTION starts a new transaction encompassing changes made by multiple SQL statements.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      23,
      19,
      21,
      3,
      24
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 194,
    "question": "Ida is a senior database administrator for a software development company. She is responsible for managing the changes to the source code, database scripts, and configuration files to ensure effective collaboration between developers. What type of quality check is Ida primarily performing to ensure the correctness and consistency of the database?",
    "choice_a": "Code quality checks",
    "choice_b": "Nullability checks",
    "choice_c": "Schema validation",
    "choice_d": "Version control checks",
    "correct_answer": "D",
    "explanation": "Code quality checks focus on the database code\u2019s correctness, efficiency, and maintainability. Nullability checks ensure that optional columns are nullable and required columns are not, and schema validation validates that the database implementation conforms to the original requirements. Version control checks validate the use of version control software in the environment, which is under Ida\u2019s area of responsibility.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      48,
      50,
      51,
      43,
      45
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 195,
    "question": "Diego, a database administrator, is experiencing performance issues with some SQL queries in his flight booking application. What should Daniel use to understand and improve the performance of the problematic SQL queries?",
    "choice_a": "SQL execution plan optimization",
    "choice_b": "Object-oriented programming (OOP)",
    "choice_c": "User experience (UX) design",
    "choice_d": "Object-relational mapping (ORM)",
    "correct_answer": "A",
    "explanation": "Object-oriented programming (OOP) makes software more modular, reusable, and scalable. User experience (UX) design focuses on improving a system\u2019s ease of use, efficiency, and usefulness. Object-relational mapping (ORM) presents relational data as objects in an object-oriented programming language, allowing developers to work with OOP languages like Java, Python, and C++ without writing the underlying database queries. SQL execution plan optimization examines query efficiencies by understanding the database engine\u2019s steps to execute the queries. A SQL explain plan or execution plan provides information about the operations performed, the order in which they occur, and the database objects used to store and access data. This information helps developers and database administrators like Diego troubleshoot performance issues and optimize query performance.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      63,
      64,
      57,
      69,
      55
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 196,
    "question": "Christine is a data center facility manager who is concerned about the temperature and humidity of her facility. She wants to ensure that her facility maintains the proper conditions for optimal equipment performance. Which of the following is a recommended range for maintaining a data center\u2019s temperature and humidity?",
    "choice_a": "Temperature between 64.4\u201380.6 degrees Fahrenheit, and dew point between 41.9\u201350.0 degrees Fahrenheit",
    "choice_b": "Temperature between 40\u201360 degrees Fahrenheit, and dew point between 35.0\u201341.9 degrees Fahrenheit",
    "choice_c": "Temperature between 55\u201370 degrees Fahrenheit, and dew point between 51.0\u201359.0 degrees Fahrenheit",
    "choice_d": "Temperature between 75\u201390 degrees Fahrenheit, and dew point between 60.0\u201370.0 degrees Fahrenheit",
    "correct_answer": "A",
    "explanation": "The correct answer is maintaining a temperature between 64.4\u201380.6 degrees Fahrenheit and dew point between 41.9\u201350.0 degrees Fahrenheit. This temperature range is recommended by the American Society of Heating, Refrigeration and Air Conditioning Engineers (ASHRAE) and permits maintaining data centers at a temperature that is friendly to electronic equipment. The recommended dew point range keeps both condensation and static electricity away, thus protecting electronic equipment from damage.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      81,
      52,
      59,
      60,
      69
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 197,
    "question": "Spike is a database administrator responsible for ensuring that the company\u2019s database has enough capacity to tolerate activity spikes. He must also maintain the database software by applying security, performance, and new feature patches. Which crucial operational task is Spike performing?",
    "choice_a": "Data partitioning",
    "choice_b": "Database recovery testing",
    "choice_c": "Monitoring and maintaining the database",
    "choice_d": "Automating routine tasks with scripts",
    "correct_answer": "C",
    "explanation": "Data partitioning divides large tables with billions of rows into smaller, more manageable pieces. Database recovery testing validates that data can be recovered from backups. Automating routine tasks with scripts improves operational consistency. Spike is monitoring and maintaining the database to ensure sufficient capacity to tolerate activity spikes and keep the software up-to-date.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      60,
      54,
      55,
      53,
      67
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 198,
    "question": "Emma is a database administrator responsible for managing an inventory system. She needs to update the inventory levels for multiple products at once but wants the flexibility to revert to specific points within the transaction if something goes wrong. Which Transaction Control Language (TCL) command should Emma use to create a marker within the transaction to allow for partial rollbacks?",
    "choice_a": "COMMIT",
    "choice_b": "ROLLBACK",
    "choice_c": "SAVEPOINT",
    "choice_d": "BEGIN TRANSACTION",
    "correct_answer": "C",
    "explanation": "COMMIT saves the changes made by a SQL statement, ROLLBACK reverts changes, and BEGIN TRANSACTION starts a new transaction that can encompass multiple SQL statements. Emma should use the SAVEPOINT command to create a marker within the transaction, allowing her to perform partial rollbacks if something goes wrong during the update process. By establishing a savepoint, she can revert the transaction to a specific point without undoing all the changes made by the SQL statements within the transaction.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      23,
      3,
      24,
      21,
      28
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 199,
    "question": "Hussain is a data systems analyst at a midsize online pet supply retailer. His manager asked him to look into some suspicious purchase activity where orders contain products that are no longer in inventory. In checking the relationships between the Order, Order_Item, and Item tables per the ERD shown, he sees that the foreign key between the Item and Order_Item tables is missing in the database. What kind of check is Hussain performing, and what must he do to resolve it?<br>*** INSERT IMAGE 180059_pt40.png",
    "choice_a": "Referential integrity: remove invalid items from Order_Item and create a foreign key constraint from Order_Item.Item_Num that references Item.Item_Num",
    "choice_b": "Referential integrity: create a foreign key constraint from Order_Item.Item_Num that references Item.Item_Num",
    "choice_c": "Domain integrity: remove invalid items from Order_Item and create a foreign key constraint from Order_Item.Item_Num that references Item.Item_Num",
    "choice_d": "Entity integrity: create a foreign key constraint from Order_Item.Item_Num that references Item.Item_Num",
    "correct_answer": "A",
    "explanation": "Hussain is performing a referential integrity check. To resolve the situation, Hussain needs to remove any existing entries in the Order_Item table that refer to nonexistent records in the Item table and then create the foreign key on Order_Item.Item_Num that references Item.Item_Num. Domain integrity validates that column values conform to business rules and column definitions, and entity integrity ensures that tables have primary keys.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      43,
      48,
      50,
      45
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 200,
    "question": "Olivia is a data systems analyst at Bright Sparks Corporation. They have recently merged with Global Illumination Ltd, which has resulted in overlapping customer databases. Olivia needs to account for the fact that Bright Sparks and Global Illumination have an overlapping customer base. What is the most efficient approach that Olivia should consider to address this overlap?",
    "choice_a": "Olivia should create an API layer to consolidate functionality",
    "choice_b": "Olivia should implement a duplicate resolution process that looks for customers with multiple active entries, validates which entry is correct, and removes the invalid, duplicate record",
    "choice_c": "Olivia should notify management of the issue",
    "choice_d": "Olivia should let the situation resolve itself over time",
    "correct_answer": "B",
    "explanation": "When two databases merge, there is the potential for duplicate entries. The best option here is for Olivia to create a duplicate resolution process. This issue will not resolve itself over time, as additional customer activity can worsen the problem. While an API layer can help maintain SQL consistency and allow data sharing, it does not directly address the problem of data redundancy that has already occurred because of the merger. Notifying management does not resolve the underlying issue.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      79,
      80,
      62,
      61,
      66
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 201,
    "question": "Enzo is a data management professional working at a health tech startup. He is optimizing a data table containing 3,520,000 patient records, which are frequently accessed but rarely updated. The table needs to be accessed quickly by several applications. Which data management task should Enzo prioritize?",
    "choice_a": "Modify existing data",
    "choice_b": "Append a new column",
    "choice_c": "Create an index",
    "choice_d": "Create a new dataset",
    "correct_answer": "C",
    "explanation": "Creating an index to cover queries on the table is correct, as it can significantly improve the speed of data retrieval operations. Modifying data, creating a new dataset, and appending a new column don\u2019t affect data retrieval.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      64,
      63,
      69,
      55,
      67
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 202,
    "question": "Ava is the head of IT security at a medium-sized company and wants to evaluate the effectiveness of the security training her employees have received on phishing attacks. Which approach should she use to assess how well her employees can recognize and respond to phishing attempts?",
    "choice_a": "Conduct a traditional classroom session on phishing prevention",
    "choice_b": "Distribute email reminders about phishing dangers to all employees",
    "choice_c": "Implement an anti-phishing simulation program",
    "choice_d": "Provide online computer-based training on information security",
    "correct_answer": "C",
    "explanation": "Implementing an anti-phishing simulation program is the best approach to evaluate the effectiveness of security training because it actively tests employees\u2019 abilities to recognize and respond to simulated phishing attacks, providing measurable results. In contrast, conducting a traditional classroom session and providing online computer-based training are methods to deliver training, but they don\u2019t assess its effectiveness. Distributing email reminders serves as security awareness, but it also does not measure employees\u2019 abilities to handle phishing attacks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      121,
      106,
      103,
      88,
      82
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 203,
    "question": "Jackie is a senior data systems analyst at an automotive parts franchise. She is working on a weekly sales summary for management and is running into performance issues. The SQL for the view she is building takes 12 minutes to run. What should Jackie do? Choose the best option.",
    "choice_a": "Create a table and insert the week\u2019s data into it",
    "choice_b": "Create a materialized view that refreshes every week",
    "choice_c": "Create an index on the view",
    "choice_d": "Add a new column to store total sales",
    "correct_answer": "B",
    "explanation": "Jackie should create a materialized view that refreshes every week, as a 12-minute refresh time is reasonable. Creating a table and inserting data into it could be a viable approach, but it would require ongoing automation to refresh the data in the coming weeks. Adding a column wouldn\u2019t improve the query\u2019s performance, and you can\u2019t create an index on a nonmaterialized view.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      63,
      64,
      69,
      79,
      55
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 204,
    "question": "Alex, a database administrator, is working on a data migration project from a legacy system to a new database. He encounters a change in business rules that makes the \u201ctitle\u201d a required field for each person record. During the migration, some records fail to load due to missing titles in the original database. What aspect of database validation should Alex focus on to resolve these issues?",
    "choice_a": "Data mapping",
    "choice_b": "Data values",
    "choice_c": "Query validation",
    "choice_d": "Index analysis",
    "correct_answer": "B",
    "explanation": "Data mapping consistently maps to similar data types as data flows between the database and the systems it interacts with. Query validation tests the correctness and performance of SQL queries, stored procedures, and views within the database and connected applications. Index analysis focuses on analyzing and optimizing database indexes to improve query performance. Meanwhile, validating data values ensures the accuracy, consistency, and completeness of data stored in the database.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      51,
      48,
      43,
      37,
      45
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 205,
    "question": "Nasira is a systems analyst at a medium-sized company that handles 100,000,000 daily transactions. With such a large number of transactions, management is worried about point-in-time recovery. Which of the following best describes what Nasira should do to put management\u2019s mind at ease?",
    "choice_a": "Increase the amount of transaction log storage",
    "choice_b": "Increase the amount of network bandwidth",
    "choice_c": "Increase the amount of CPU",
    "choice_d": "Reduce the average query response time",
    "correct_answer": "A",
    "explanation": "Increasing the amount of storage for transaction logging helps point-in-time recovery by ensuring sufficient space to hold transaction logs until the next partial/full backup. While increasing the amount of network or CPU may be necessary to support the daily transaction volume, neither directly affects point-in-time recovery goals. Similarly, reducing the average query response time may improve customer satisfaction but doesn\u2019t affect point-in-time recovery.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      135,
      140,
      145,
      147,
      148
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 206,
    "question": "Karen is a security analyst at a large financial institution. She has been tasked with implementing security controls for the facility to monitor and record the activity of people inside the building. Which of the following is an advantage of using security guards over technical control systems?",
    "choice_a": "Guards can make decisions that technical control systems cannot.",
    "choice_b": "Guards are less expensive to deploy than technical control systems.",
    "choice_c": "Guards are less prone to social engineering attacks.",
    "choice_d": "Guards are more effective at identifying individuals.",
    "correct_answer": "A",
    "explanation": "Security guards are able to use human judgment to make decisions that technical control systems cannot, such as responding to an emergency situation or handling a unique situation. While technical control systems are important, they are limited by their programming and cannot deviate from their predetermined rules. Guards are typically more expensive to deploy than technical control systems because of the ongoing cost of paying the guards. Unlike technical systems, guards are susceptible to social engineering attacks and may make mistakes that compromise security. Technical control systems such as facial recognition can be more effective at identifying individuals, whereas guards can make mistakes and may not be as reliable in identifying people.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      110,
      108,
      121,
      104,
      111
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 207,
    "question": "An existing database table named \u201csales\u201d contains information about each company\u2019s sales. Which SQL commands should be used to update the sale amount of a specific transaction from $100 to $200?",
    "choice_a": "CREATE TABLE, INSERT",
    "choice_b": "SELECT, INSERT",
    "choice_c": "UPDATE, SET",
    "choice_d": "ALTER TABLE, UPDATE",
    "correct_answer": "C",
    "explanation": "CREATE TABLE defines a new table, SELECT retrieves data from a table, and ALTER TABLE modifies the structure of an existing table. To modify the value of an existing entry in the table, use the UPDATE command, of which the SET clause is a component.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      21,
      19,
      3,
      28,
      23
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 208,
    "question": "Huy is an IT manager at a small business and wants to ensure her employees are aware of different types of malware threats. Which type of malware is characterized by pretending to be a legitimate piece of software that a user might want to download and install, while also carrying a malicious hidden payload?",
    "choice_a": "Viruses",
    "choice_b": "Rootkits",
    "choice_c": "Trojan horses",
    "choice_d": "Spyware",
    "correct_answer": "C",
    "explanation": "Trojan horses are the correct answer because they masquerade as legitimate software that a user might want to download and install, but also carry a malicious hidden payload that performs unwanted actions behind the scenes. Viruses are malicious code objects that spread from system to system after some human action, carrying a malicious payload with the intent to steal data or disrupt system activity. Rootkits were originally designed for privilege escalation, but the term is now used to describe software techniques designed to hide other software on a system. Spyware is malware that gathers information without the user\u2019s knowledge or consent and reports it back to the malware author, who can use it for various purposes, such as identity theft, monetary theft, or even espionage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      94,
      116,
      88
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 209,
    "question": "Gerard is a database administrator at a bank and wants to enforce a business rule that will prevent customers from withdrawing more money than they have in their accounts. Which database object should he use to implement this business rule?",
    "choice_a": "Stored procedure",
    "choice_b": "View",
    "choice_c": "Trigger",
    "choice_d": "Function",
    "correct_answer": "C",
    "explanation": "While stored procedures are useful for encapsulating business logic, they do not execute automatically when an event occurs. Functions are precompiled sets of SQL statements that perform specific tasks or computations and commonly return a single value. A view presents the result set of a SELECT statement as a virtual table. Triggers execute SQL automatically before or after table data changes. Gerard can use a before-update trigger to ensure that the available account balance exceeds the withdrawal amount, preventing customers from overdrawing their accounts.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      24,
      26,
      23,
      20,
      3
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 210,
    "question": "Nadia is a database administrator for a midsize company that relies heavily on its customer relationship management (CRM) database. Over the last few days, Nadia has noticed that the database\u2019s CPU utilization has spiked, from a baseline of around 70 percent during peak load to consistently using 90 percent. Nadia wants to identify the reason for this sudden increase in CPU usage. Which of the following could potentially explain this change in resource utilization?",
    "choice_a": "The company has just implemented a connection pooling strategy for its applications.",
    "choice_b": "There is a sharp increase in the database replication lag.",
    "choice_c": "The number of failed database loads has increased.",
    "choice_d": "The company has recently updated the CRM software.",
    "correct_answer": "D",
    "explanation": "Any changes in a system, such as a software update, can affect the performance of a database. If Maria\u2019s company has recently updated its CRM software, it could be consuming more resources, which is the reason for the increase in CPU usage.<br>A connection pooling strategy should reduce resource usage by efficiently managing active database connections. An increase in database replication lag could be a symptom of increased CPU utilization and is unlikely to be a cause. Database loads can fail for many reasons\u2014since the CPU isn\u2019t saturated, it is an unlikely cause for this increase.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      54,
      55,
      60,
      66,
      63
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 211,
    "question": "Emma is a database administrator for an e-commerce company that handles 100,000,000 global transactions daily. She is considering partitioning the sales table to distribute the query workload across multiple database servers. Which partitioning technique would be most suitable for Emma to implement on the sales table?",
    "choice_a": "Range partitioning",
    "choice_b": "List partitioning",
    "choice_c": "Composite partitioning",
    "choice_d": "Hash partitioning",
    "correct_answer": "C",
    "explanation": "Because of the transactions\u2019 high volume and global nature, a composite approach involving multiple partitioning techniques is optimal. For example, Emma could implement range partitioning to divide the sales table by month and year and then use hash partitioning to spread the data for each year across multiple subpartitions. Range partitioning does not necessarily distribute the data across partitions if the data is skewed, and list partitioning is good for partitioning based on a set of discrete values. Hash partitioning does a good job of evenly distributing values and is a component of the composite partitioning approach.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      39,
      49,
      48,
      38,
      44
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 212,
    "question": "Anjay, a newly appointed data systems analyst at a financial firm, is responsible for setting up a new secure environment for storing sensitive financial data. The firm recently experienced a security breach, and there\u2019s an urgency to prevent future incidents. To comply with organizational policies, which section of the Standard Operating Procedures (SOPs) should Anjay look to for guidance? Choose the best answer.",
    "choice_a": "Disaster recovery plan",
    "choice_b": "Security management",
    "choice_c": "Data backup and restoration",
    "choice_d": "Incident response plan",
    "correct_answer": "B",
    "explanation": "Security management specifically addresses database security issues, including guidelines on user account creation, access-level management, and credential management. Data backup and restoration is incorrect because it primarily deals with the procedures for backing up data and restoring it. The disaster recovery plan is also incorrect as this SOP mostly contains information about how to recover the database in the event of a disaster. While an incident response plan is crucial for reacting to a security incident, it doesn\u2019t address the preventive measures needed to secure the database.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      83,
      88,
      91,
      106,
      85
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 213,
    "question": "Philip is looking to reduce his organization\u2019s software budget by embracing open source. Which of the following relational databases can he consider?",
    "choice_a": "Oracle",
    "choice_b": "Microsoft SQL Server",
    "choice_c": "MariaDB",
    "choice_d": "Aurora",
    "correct_answer": "C",
    "explanation": "Aurora is adapted from open source by AWS. Oracle and Microsoft SQL Server are both proprietary database offerings.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      9,
      14,
      2,
      28,
      10
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 214,
    "question": "Salim is building an application for managing online recipes. His existing recipe data is stored in JSON. What database engine best matches his needs?",
    "choice_a": "Neo4j",
    "choice_b": "Oracle",
    "choice_c": "DynamoDB",
    "choice_d": "PostgreSQL",
    "correct_answer": "C",
    "explanation": "A key-value database best matches Salim\u2019s requirements. Neo4j is a graph database, while both Oracle and PostgreSQL are relational databases.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      10,
      2,
      14,
      12,
      9
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 215,
    "question": "Deirdre is a marketing manager for a small e-commerce company. She is working on improving the company\u2019s online presence through social media marketing. Deirdre wants to analyze various social media channels to determine which would be the most effective for engaging her target audience. What primary factor should she consider when selecting a social media platform for her marketing campaign? Choose the best answer.",
    "choice_a": "The budget allocated for social media advertising",
    "choice_b": "The time and effort required to maintain the platform",
    "choice_c": "The number of posts required per week",
    "choice_d": "The platform\u2019s popularity among her target audience",
    "correct_answer": "D",
    "explanation": "The time and effort required to maintain the platform are relevant but secondary to its popularity among her target audience. Deirdre\u2019s primary focus should be on engaging her audience effectively.<br>The number of posts required per week is only one factor in determining the effectiveness of a social media marketing campaign. Instead, it is more important to focus on selecting a platform that resonates with her target audience and provides an opportunity for meaningful engagement.<br>The budget allocated for social media advertising is important, but the primary factor should be the platform\u2019s popularity among the target audience. Spending money on a platform without her audience would be inefficient.<br>The platform\u2019s popularity among her target audience is the correct answer because this factor will help ensure that Deirdre\u2019s marketing efforts reach the most likely to be interested in her company\u2019s products or services.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      52,
      81
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 216,
    "question": "Belinda is creating a data retention policy for her organization and is trying to select a maximum retention period. Which one of the following criteria would be most important to use in selecting the maximum data retention period?",
    "choice_a": "Length of time that the data is needed for business purposes",
    "choice_b": "Legal requirements to preserve data",
    "choice_c": "Amount of available storage",
    "choice_d": "Difficulty of destroying the data",
    "correct_answer": "A",
    "explanation": "When creating a data retention policy, the most appropriate criterion to use in selecting the maximum retention period is the length of time that the data is needed for business purposes. This ensures that the data is retained only as long as it is necessary to meet business requirements and reduces the risks and costs associated with retaining unnecessary data. Legal requirements to preserve data may dictate a minimum retention period, but there are more suitable criteria for selecting the maximum retention period. The amount of available storage may also drive a minimum retention period, but data should never be retained simply because you have the storage to do so. The difficulty of destroying the data should not dictate how long the organization retains the data.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      86,
      82,
      84,
      97,
      101
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 217,
    "question": "You are a database administrator, and your employer has sustained damages to the building where you house your servers and databases. You need to configure and deploy new systems in another part of the building to restore operations to their pre-disaster state. Which documentation will help you do so quickly, consistently, and efficiently?",
    "choice_a": "Build documentation",
    "choice_b": "Continuity of operations plan",
    "choice_c": "System security plan",
    "choice_d": "Disaster recovery manual",
    "correct_answer": "A",
    "explanation": "Build documentation provides step-by-step instructions for configuring and deploying critical systems to ensure consistency and accuracy while minimizing errors. Continuity of operations plans contain information about maintaining operations in the face of adverse circumstances, rather than restoring operations after a disaster. The system security plan outlines modifications to security controls during a disaster response. The disaster recovery manual contains high-level overviews of the disaster recovery plan, department-specific plans, technical guides, and checklists. It would not contain the detailed information needed to rebuild operations after a disaster.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      73,
      71,
      66,
      68,
      67
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 218,
    "question": "Carlli is a junior database administrator at a small company. She needs to add a new column named \u201cemail\u201d to an existing table called \u201cemployees\u201d in their relational database. Which SQL statement should Carlli use to achieve this?",
    "choice_a": "CREATE COLUMN email VARCHAR(255) IN employees;",
    "choice_b": "UPDATE TABLE employees ADD COLUMN email VARCHAR(255);",
    "choice_c": "ALTER TABLE employees ADD COLUMN email VARCHAR(255);",
    "choice_d": "INSERT INTO employees (email) VALUES (VARCHAR(255));",
    "correct_answer": "C",
    "explanation": "The CREATE COLUMN statement does not exist in SQL. The UPDATE statement modifies existing data within a table and is syntactically incorrect in this context, and the INSERT INTO adds new rows to a table. The ALTER TABLE statement changes the structure of an existing table, in this case, adding a new column.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      3,
      19,
      21,
      5,
      28
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 219,
    "question": "Alice wants to eliminate duplicate rows from her result set. Which SQL command should she use?",
    "choice_a": "DELETE DUPLICATES",
    "choice_b": "CREATE UNIQUE INDEX",
    "choice_c": "TRUNCATE DUPLICATES",
    "choice_d": "SELECT DISTINCT",
    "correct_answer": "D",
    "explanation": "DELETE DUPLICATES and TRUNCATE DUPLICATES are not valid SQL commands. While creating a unique index can help enforce uniqueness constraints on a table, it does not remove existing duplicate rows. The SELECT DISTINCT command retrieves unique rows from a table based on specific columns. It eliminates duplicate rows in the result set.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      21,
      22,
      26,
      27
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 220,
    "question": "Francesca is an administrator setting up backups for her file server. She would like to back up her server each weekday. Which backup method would best suit Francesca if she would like to use the least amount of disk space?",
    "choice_a": "Incremental",
    "choice_b": "Differential",
    "choice_c": "Disk-to-disk",
    "choice_d": "Full",
    "correct_answer": "A",
    "explanation": "The incremental backup method would best suit Francesca\u2019s needs, as it uses the least amount of disk space while still allowing for daily backups. Incremental backups store only the changes made since the last backup, regardless of whether it was a full, differential, or incremental backup. This approach minimizes storage requirements compared to differential backups, which store all changes since the last full backup, resulting in larger backup sizes over time. Disk-to-disk backups refer to the storage medium, not the backup strategy, and full backups, while comprehensive, consume the most disk space as they capture a complete copy of the data each time.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      145,
      147,
      149,
      150,
      146
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 221,
    "question": "Janisha, a junior data systems analyst in a fast-growing startup, is tasked with executing a major update to the company\u2019s database software and validating the associated dependencies. To ensure consistent operations, which subject area of the standard operating procedures (SOPs) should Janisha refer to?",
    "choice_a": "Data Backup and Restoration",
    "choice_b": "System Updates and Upgrades",
    "choice_c": "Troubleshooting",
    "choice_d": "Change Management",
    "correct_answer": "B",
    "explanation": "The System Updates and Upgrades section outlines procedures to install patches, updates, or upgrades to the database. It also documents the system\u2019s dependencies. Data Backup and Restoration is incorrect because it details when and how to perform data backups and the steps for restoring data. Troubleshooting is incorrect as it outlines steps for diagnosing and resolving performance irregularities and edge cases, while Change Management describes how to make and communicate changes.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      45,
      44,
      50,
      48,
      49
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 222,
    "question": "Giancarlo is a database developer at a large manufacturing company. The company needs a database to store customer orders, product inventory, and shipment details. Additionally, they want to track shipping performance using key performance indicators (KPIs) such as shipping time, order accuracy, and delivery time. Which use case category should Giancarlo focus on to design the company\u2019s database to generate reports and visualize these KPIs for the management team?",
    "choice_a": "Data Retrieval",
    "choice_b": "Data Capture",
    "choice_c": "Data Storage",
    "choice_d": "Data Processing",
    "correct_answer": "A",
    "explanation": "Data Capture is a use case category focusing on collecting, validating, and cleaning data for accuracy and completeness. While important, Data Capture does not directly address the company\u2019s requirements for generating reports and visualizations of KPIs.<br>Data Storage is a use case category that impacts the type of storage needed, informed by size and speed requirements. Although Data Storage is essential in designing the database, it does not directly address the company\u2019s requirements for generating reports and visualizations of KPIs.<br>Data Processing is a use case category that focuses on manipulating data within the database, including data aggregation, calculations, and transformations. Data Processing is often related to Data Retrieval but does not directly address the company\u2019s requirements for generating reports and visualizations of KPIs.<br>The Data Retrieval use case category focuses on how users access the data they need from the database. By focusing on data retrieval, Alice can design the database to facilitate reports, visualizations, and management-facing dashboards that display the required KPIs for the manufacturing company. Database and application developers are essential stakeholders when designing retrieval-related use cases, as end users typically interact with the database indirectly through an application.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      37,
      40,
      36,
      38,
      43
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 223,
    "question": "Herman is a database administrator tasked with setting up a new database for his company. To ensure optimal performance and scalability, which of the following components should Herman consider while acquiring hardware assets for the database? Choose the best answer.",
    "choice_a": "Schema, data structures, and configuration settings",
    "choice_b": "Domain Name System (DNS) and firewalls",
    "choice_c": "Processing capacity, memory, storage, and network bandwidth",
    "choice_d": "The number of database clients",
    "correct_answer": "C",
    "explanation": "The database schema and its data structures are part of the database design, not the hardware assets needed for the physical infrastructure of the database system. The Domain Name System (DNS) and firewalls are network and security infrastructure components. While the total number of database clients informs configuration settings, Herman must focus on processing capacity, memory, storage, and network bandwidth when acquiring hardware assets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      44,
      38,
      39,
      49,
      45
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 224,
    "question": "Paulina is setting the permissions that a user will have to a database under her control. What is the most appropriate philosophy to use when setting these permissions?",
    "choice_a": "Give the user a set of privileges that cover any duties they might be assigned in the future",
    "choice_b": "Give the user the specific permissions that they asked for",
    "choice_c": "Give the user the minimum set of privileges necessary to perform their job function",
    "choice_d": "Give the user unrestricted permissions on the database",
    "correct_answer": "C",
    "explanation": "The most appropriate philosophy to use when setting database permissions for a user is to give them the minimum set of privileges necessary to perform their job function, which is consistent with the least privilege principle. This approach helps to prevent unintended consequences, such as the user accidentally or maliciously modifying or deleting data they shouldn\u2019t have access to. Giving the user a set of privileges that cover any duties they might be assigned in the future or giving them the specific permissions that they asked for without review for necessity would be inappropriate as it increases the risk of unintended consequences. Giving the user unrestricted permissions on the database would be a violation of the least privilege principle and could lead to serious security breaches.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      85,
      83,
      103,
      87,
      91
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 225,
    "question": "Hakim is a data systems analyst for a rapidly growing tech startup. Leadership projects a fivefold increase in application users and is planning a horizontal scaling approach to meet consumer demand. What should Hakim do to support this effort? Choose the best answer.",
    "choice_a": "Increase the size of the connection pool",
    "choice_b": "Shrink the batch-load window",
    "choice_c": "Increase the amount of storage for system logging",
    "choice_d": "Disable transaction logging",
    "correct_answer": "A",
    "explanation": "Hakim should increase the connection pool size to accommodate the increase in application connections. While increasing the amount of storage for system logging may be required, it is less directly related to supporting increased demand. Disabling transaction logging negatively impacts point-in-time recovery, and shrinking the batch window won\u2019t help meet additional demand.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      59,
      57,
      55,
      67,
      65
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 226,
    "question": "As a data systems analyst for an insurance company, Tara\u2019s primary focus is data protection. Which of the following activities is not related to her primary job role? Choose the best answer.",
    "choice_a": "Monitoring network utilization",
    "choice_b": "Monitoring full database backups",
    "choice_c": "Managing the amount of storage for transaction logging",
    "choice_d": "Determining the frequency of partial backups",
    "correct_answer": "A",
    "explanation": "Transaction logging, partial backups, and full backups directly relate to data protection. While monitoring network utilization is essential to an operationally stable database, it does not directly relate to data protection.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      97,
      82,
      106,
      103,
      95
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 227,
    "question": "Paolo, a database administrator working for a logistics company, wants to improve the consistency and performance of his database. He notices significant parsing activity in the database. This parsing surprises him as the queries all retrieve status activity for different packages. What should Paul implement to reduce the need for the database to parse queries and improve performance?",
    "choice_a": "Index analysis",
    "choice_b": "Covered queries",
    "choice_c": "Referential integrity",
    "choice_d": "Bind variables",
    "correct_answer": "D",
    "explanation": "Covered queries retrieve data directly from an index, referential integrity checks data integrity rules and constraints, and index analysis focuses on analyzing and optimizing database indexes to improve query performance. Bind variables replace literal values with placeholders in SQL queries, reducing the database\u2019s need to parse queries.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      33,
      21,
      17,
      4
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 228,
    "question": "Karina is a database administrator working for a medium-sized company. She wants to create a new table to store customer data and then add a new record for Zaenib Haddin. Which SQL commands should Karina use to complete her task?",
    "choice_a": "CREATE TABLE, SELECT",
    "choice_b": "CREATE TABLE, INSERT",
    "choice_c": "ALTER TABLE, UPDATE",
    "choice_d": "DROP TABLE, DELETE",
    "correct_answer": "B",
    "explanation": "Although CREATE TABLE is the correct command to create a new table, SELECT is a read-only operation used to retrieve data from a table, not to insert a new record. ALTER TABLE modifies an existing table, and DROP TABLE permanently removes a table. The CREATE TABLE command creates a new table, followed by an INSERT with Zaenib\u2019s data.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      21,
      19,
      3,
      20,
      5
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 229,
    "question": "Abir is researching relational databases and is under a mandate from his leadership to use AWS. Which of the following is not a viable option?",
    "choice_a": "Aurora",
    "choice_b": "Oracle",
    "choice_c": "Microsoft SQL Server",
    "choice_d": "BigQuery",
    "correct_answer": "D",
    "explanation": "You can run both Oracle and Microsoft SQL Server in AWS. Aurora is a proprietary AWS offering. BigQuery runs exclusively within the Google Cloud Platform.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      42,
      44,
      45,
      39,
      37
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 230,
    "question": "Victoria is the system administrator for a large data analytics firm. She requires extensive permissions to carry out some of her job functions. Which type(s) of accounts should she use in her work?",
    "choice_a": "Standard user account only",
    "choice_b": "Both a standard user account and an administrator account",
    "choice_c": "Administrator account only",
    "choice_d": "Service account only",
    "correct_answer": "B",
    "explanation": "The most appropriate option for Victoria would be to use both a standard user account and an administrator account in her work. This would allow her to perform her duties that require administrative privileges while also ensuring that she does not use those privileges when they are not required. A standard user account has limited access and cannot make system-wide changes, while an administrator account has elevated privileges and can make such changes. Using a standard account for everyday tasks can help protect against malicious software or unauthorized changes. On the other hand, using only an administrator account would provide excessive privileges that could be exploited by attackers. Using only a service account would not be appropriate as those are typically used for automated tasks rather than individual users.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      91,
      85,
      83,
      103,
      88
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 231,
    "question": "Amanda is a database administrator for a large logistics company. When testing an application update, she notices the database an increase in database parsing activity. What is the most likely cause of this change?",
    "choice_a": "An index is missing.",
    "choice_b": "A primary key has invalid values.",
    "choice_c": "A foreign key is missing.",
    "choice_d": "An absence of bind variables in the application code.",
    "correct_answer": "D",
    "explanation": "An increase in parsing activity indicates the optimizer needs to figure out how to run the query. Without bind variables, the database must parse identical queries except for parameter values. A missing index may cause full table scans. Missing foreign keys or invalid values for the primary key doesn\u2019t affect parsing.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      63,
      64,
      57,
      55,
      66
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 232,
    "question": "Rob is reviewing a web application tied to the patient records system for a hospital system. The system is used by doctors and nurses to write updates on each patient\u2019s health status. What term best describes the type of information would Rob most likely expect to find in this system?",
    "choice_a": "PCI",
    "choice_b": "PHI",
    "choice_c": "PFI",
    "choice_d": "PII",
    "correct_answer": "B",
    "explanation": "Rob should expect to find protected health information (PHI) in a patient medical records system. This is an example of personally identifiable information (PII), but PHI is a more specific term and, therefore, a better answer here. There is no mention of the system being used for business transactions, so it is unlikely that this type of system would contain personal financial information (PFI) or payment card information (PCI).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      99,
      98,
      97,
      100,
      102
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 233,
    "question": "Ida, a data systems analyst at a growing e-commerce company, needs to improve the availability of her company\u2019s database. Which of the following best describes what she needs to focus on?",
    "choice_a": "Manage batch workload windows",
    "choice_b": "Implement a replication strategy",
    "choice_c": "Enhance the database backup procedure",
    "choice_d": "Improve the efficiency of transaction logs",
    "correct_answer": "B",
    "explanation": "As this scenario focuses on improving availability, working on a replication strategy is the best answer. The batch workload window is when batch jobs execute, database backups are a means of data protection, and transaction log efficiency impacts database performance and data protection.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      140,
      137,
      139,
      135,
      143
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 234,
    "question": "Wendy is responsible for the security of a database located in an Italian data center that contains personally identifiable information of European Union residents. Which one of the following regulations is most likely to govern her work?",
    "choice_a": "PCI DSS",
    "choice_b": "GDPR",
    "choice_c": "GLBA",
    "choice_d": "HIPAA",
    "correct_answer": "B",
    "explanation": "The regulation that would most likely govern Wendy\u2019s work is the General Data Protection Regulation (GDPR) since it applies to the handling of personal data of EU residents. The Payment Card Industry Data Security Standard (PCI DSS) and the Health Insurance Portability and Accountability Act (HIPAA) are specific to certain types of data, and the Gramm-Leach-Bliley Act (GLBA) is specific to financial institutions, so they would not apply to Wendy\u2019s situation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      102,
      101,
      98,
      97,
      82
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 235,
    "question": "Sophia is a system administrator at a growing company and wants to educate her team about different types of malware to increase their security awareness. Which type of malware is specifically designed to block a user\u2019s access to their computer or data until a specific demand is met?",
    "choice_a": "Rootkit",
    "choice_b": "Virus",
    "choice_c": "Spyware",
    "choice_d": "Ransomware",
    "correct_answer": "D",
    "explanation": "Ransomware is the correct answer because it blocks a user\u2019s access to their computer or data until a specific demand, usually a payment, is met. This is often achieved by encrypting the files with a secret key and then selling the decryption key. Rootkits are a type of malware that was initially designed for privilege escalation but is now used to describe software techniques designed to hide other software on a system. Spyware is malware that gathers information without the user\u2019s knowledge or consent and reports it to the malware author. Viruses are malicious code objects that spread from system to system after some human action, carrying a malicious payload that carries out the virus author\u2019s intent, such as stealing data or disrupting system activity.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      120,
      121,
      92,
      101,
      106
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 236,
    "question": "Bob is director of production in a document conversion firm. He has estimated that the cost of replacement of each production scanner is $15,000. He is worried about the risk of an electrical surge damaging one of the scanners. These surges have occurred in the past and resulted in a $2,000 repair bill. What is the SLE in this scenario?",
    "choice_a": "$15,000",
    "choice_b": "$2,000",
    "choice_c": "$13,000",
    "choice_d": "$30,000",
    "correct_answer": "B",
    "explanation": "In this scenario, the single loss expectancy (SLE) is $2,000. SLE represents the monetary value associated with a single loss event. In this case, the loss event being considered is an electrical surge damaging a production scanner, which has historically resulted in a $2,000 repair bill. Although the replacement cost of each scanner is $15,000, the loss being assessed is related to the cost of repairing the damage caused by an electrical surge, not the cost of replacing the scanner entirely. Therefore, the correct SLE value is $2,000.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      106,
      82,
      101,
      86,
      102
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 237,
    "question": "Aoife is a database administrator at a growing company and needs to automate some database operations. She wants to use a platform-independent language that can easily integrate with other applications. Which programming language should Aoife choose for her client-side scripts?",
    "choice_a": "PL/SQL",
    "choice_b": "T-SQL",
    "choice_c": "Python",
    "choice_d": "Bash",
    "correct_answer": "C",
    "explanation": "PL/SQL is a proprietary language specific to Oracle databases, while T-SQL is specific to Microsoft SQL Server databases. Bash is most commonly found on Linux distributions. Python is a versatile general-purpose programming language that runs on various platforms, including Linux and Windows. It is easy to integrate with other applications and is highly suitable for automating everyday tasks across multiple database platforms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      32,
      4,
      34,
      30
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 238,
    "question": "Viviana is an IT manager experiencing an emergency and having to recover database backups at the recovery site. The system was configured to make periodic bulk transfers of transaction information to the warm site. Which database replication method has most likely been used?",
    "choice_a": "Database dumping",
    "choice_b": "Remote mirroring",
    "choice_c": "Log shipping",
    "choice_d": "On-site backups",
    "correct_answer": "C",
    "explanation": "In this scenario, log shipping is the most likely database replication method used. Log shipping involves periodic bulk transfers of transaction logs to a secondary site, making it suitable for Viviana\u2019s warm site setup. In contrast, database dumping creates full copies of the database, which is less efficient for periodic bulk transfers. Remote mirroring offers near real-time replication, which is not in line with the periodic bulk transfer described. Finally, on-site backups refer to storing backups within the organization\u2019s premises, which is unrelated to the replication method used for the recovery site.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      140,
      135,
      146,
      137,
      150
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 239,
    "question": "Ben needs to destroy a file containing sensitive information that is stored on a hard disk that the organization will continue to use. Which one of the following destruction methods would be the best way to handle this task?",
    "choice_a": "Mechanical destruction",
    "choice_b": "Securely wipe the file",
    "choice_c": "Formatting the disk",
    "choice_d": "Deleting the file",
    "correct_answer": "B",
    "explanation": "Securely wiping the file with a specialized data destruction tool will remove all traces of the sensitive data while still permitting the disk to be used. Formatting the disk and deleting the file are not sufficient methods to securely delete sensitive information. Mechanically destroying the drive would destroy the data, but it would not permit reuse of the disk.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      86,
      92,
      97,
      101,
      82
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 240,
    "question": "Grant is a database administrator at a car dealership. He wants to create a query to retrieve a list of all car manufacturers from two different tables, Table A and Table B, identifying only the brands in Table A and eliminating any overlap with Table B. What SQL operation should he use?",
    "choice_a": "EXCEPT",
    "choice_b": "UNION",
    "choice_c": "INTERSECT",
    "choice_d": "UNION ALL",
    "correct_answer": "A",
    "explanation": "UNION retrieves the distinct values from both tables, INTERSECT retrieves the common elements of the two tables, and UNION ALL retrieves all elements from both tables, including duplicates. The EXCEPT operation in SQL retrieves the difference between two tables, returning all elements that exist only in the first table and not in the second.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      25,
      21,
      3,
      28
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 241,
    "question": "Brandon would like to prevent users in his organization from reusing old passwords in the future. Which type of policy should he create?",
    "choice_a": "Password complexity",
    "choice_b": "Password reuse",
    "choice_c": "Password length",
    "choice_d": "Password history",
    "correct_answer": "D",
    "explanation": "Brandon should create a password history policy to prevent users from reusing old passwords. This policy specifies how many unique passwords a user must set before they are allowed to reuse an old password. By implementing a password history policy, users will be required to use a new password each time they change it, and the previous passwords will be stored to ensure that they are not reused in the future. Password expiration, complexity, and length policies all focus on other aspects of password security. Password expiration requires users to change their passwords after a certain amount of time has passed, password complexity specifies requirements for the type of characters used in a password, and password length requires a minimum number of characters in a password. While these policies are important for password security, they do not address the specific issue of preventing password reuse.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      90,
      89,
      91,
      88,
      106
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 242,
    "question": "Brian manages a very large database containing several items of sensitive personal information. He is most concerned about the fact that the database contains Social Security numbers (SSNs). In an effort to protect that data, he replaces the first five digits of each SSN with asterisks (*). What term best describes what he has done?",
    "choice_a": "Encryption",
    "choice_b": "Hashing",
    "choice_c": "Data masking",
    "choice_d": "Database deidentification",
    "correct_answer": "C",
    "explanation": "Brian has masked the data by replacing sensitive information with a synthetic version of the same data. Encryption or hashing are technical mechanisms for protecting data that require the use of a specialized algorithm. Brian has removed the SSN as a potential identifier, but the scenario indicates that there are other sensitive personal fields in the database, so we can\u2019t be certain that he has deidentified the database.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      93,
      98,
      97,
      94,
      92
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 243,
    "question": "Jane, a network engineer at a growing company, is setting up port security on several switches to protect against unauthorized devices being connected to the network. What mode of port security should she choose if she wants the most secure method of limiting the MAC addresses allowed on each switch port?",
    "choice_a": "Static mode",
    "choice_b": "Dynamic mode",
    "choice_c": "Sticky mode",
    "choice_d": "QoS mode",
    "correct_answer": "A",
    "explanation": "Static mode is the most secure way to implement port security, as the administrator manually configures each switch port with the allowable MAC addresses. This ensures that only authorized devices can connect to the network. Dynamic or \u201csticky\u201d mode is faster to configure but can be riskier since it memorizes the first MAC address seen on a given port and may leave active but unused switch ports vulnerable. QoS mode is not related to port security; it is a method for configuring routers to prioritize certain types of network traffic.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      113,
      114,
      83,
      103,
      91
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 244,
    "question": "Sally is a manager in charge of disaster recovery planning for her organization. She put together a team of individuals from different departments in her organization and is meeting with them in a conference room. During the meeting, Sally presents a ransomware scenario for discussion. What type of test is Sally conducting with her DR team?",
    "choice_a": "Read-through",
    "choice_b": "Full-interruption",
    "choice_c": "Structured walk-through",
    "choice_d": "Simulation",
    "correct_answer": "C",
    "explanation": "Sally is conducting a structured walk-through with her DR team, as she has assembled individuals from various departments and presented a specific ransomware scenario for discussion. This approach allows participants to review and evaluate the disaster recovery plan step-by-step. In contrast, a read-through test typically involves team members individually reviewing the plan for accuracy and completeness. A full-interruption test requires halting production systems to test the DR plan, which is not happening in this case. Finally, a simulation test involves actually activating disaster recovery resources.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      141,
      132,
      133,
      136,
      142
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 245,
    "question": "Mary is an IT manager for a small business. She is responsible for protecting data stored in her organization\u2019s database. Which one of the following security controls would best protect this data at rest?",
    "choice_a": "Transparent Data Encryption",
    "choice_b": "Transport Layer Security",
    "choice_c": "Hypertext Transfer Protocol Secure",
    "choice_d": "Secure Sockets Layer",
    "correct_answer": "A",
    "explanation": "Transparent Data Encryption (TDE) is a technology specifically designed to protect data at rest in a database. Transport Layer Security (TLS), Secure Sockets Layer (SSL), and the Hypertext Transfer Protocol Secure (HTTPS) are all technologies used to protect data in transit over a network.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      92,
      97,
      100,
      95,
      106
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 246,
    "question": "Silvia, a database developer, wants to improve the performance of her SQL queries. She has noticed that some queries could be more efficient since they currently access the underlying table to retrieve their results. What concept should Silvia focus on to ensure the database retrieves all necessary data directly from an index, thereby improving query performance?",
    "choice_a": "Bind variables",
    "choice_b": "Covered queries",
    "choice_c": "Referential integrity",
    "choice_d": "Scalability validation",
    "correct_answer": "B",
    "explanation": "Bind variables replace literal values with placeholders in SQL queries and do not directly address the issue of retrieving all necessary data from an index. Referential integrity involves testing the enforcement of data integrity rules and constraints, and scalability validation focuses on the database system\u2019s ability to handle increased loads. Covered queries retrieve all the required data for the query directly from an index without accessing the actual table data.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      63,
      64,
      69,
      57,
      54
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 247,
    "question": "Sarah is a security officer at a large corporation. Her company is concerned about unauthorized individuals entering the building and gaining access to sensitive information. Which of the following technologies could best prevent unauthorized individuals from gaining access to the building?",
    "choice_a": "Badge readers",
    "choice_b": "Alarms",
    "choice_c": "Signage",
    "choice_d": "Guards",
    "correct_answer": "A",
    "explanation": "Badge readers can ensure that only authorized personnel with the correct credentials can enter the building, making it difficult for unauthorized individuals to gain access to sensitive information. Guards may be helpful, but they can be expensive to hire and can\u2019t cover every entrance point at all times. Signage may provide a warning, but it doesn\u2019t physically prevent unauthorized individuals from entering the building. Alarms may be useful, but they are reactive and won\u2019t prevent access without additional measures in place, such as badge readers.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      108,
      88,
      110,
      85,
      83
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 248,
    "question": "Leila received a report that some of her application users are occasionally seeing inconsistent data. Knowing that she is using Hibernate to abstract the database code from her Java code, what is her next best course of action?",
    "choice_a": "Replace Hibernate with hand-coded SQL",
    "choice_b": "Investigate cache settings in Hibernate to see if it is the source of the data inconsistency",
    "choice_c": "Reboot the database",
    "choice_d": "Put a disclaimer on her application to let users know the data they see is eventually consistent",
    "correct_answer": "B",
    "explanation": "Whenever you use an ORM, it is possible for data cached within the ORM to not reflect the current state of the database. Replacing the Hibernate SQL with hand-coded SQL is not necessary. An application disclaimer violates the users\u2019 trust in the data. While rebooting the database might cause the ORM cache to update, investigating the cache settings is the best approach.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      18,
      17,
      16,
      6,
      23
    ],
    "source": "180059_Practice Test"
  },
  {
    "id": 249,
    "question": "What uniquely identifies a record in a relational database?",
    "choice_a": "Primary key",
    "choice_b": "Tuple",
    "choice_c": "Row",
    "choice_d": "Table",
    "correct_answer": "A",
    "explanation": "Data in a table consists of rows, also known as tuples. A primary key uniquely identifies a record.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      20,
      3,
      19,
      2,
      25
    ],
    "source": "180059_Practice Test"
  }
];
